import common from "./common"
import featuresPay from "./feature"

const pl = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produkt/Warianty",
        serialNumber: "Numer Seryjny",
        noProductsFound: "Nie znaleziono produktów",
        searchByProductSku: "Szukaj według produktu/SKU",
        searchSerialNumbers: "Szukaj numerów seryjnych",
        transactionDetails: "Szczegóły Transakcji",
        notAvailable: "N/D",
        mainWarehouse: "Główny Magazyn"
    },
    new_build_banner: {
        title: 'Nowa wersja:',
        is_available: 'jest już dostępna',
        fallback_title: 'Nowa wersja aplikacji jest dostępna',
        desc: 'Odśwież, aby uzyskać najnowsze funkcje i ulepszenia.',
        refreshing: 'Odświeżanie…',
        refresh_now: 'Odśwież teraz',
        later: 'Później',
        you_are_on: "jesteś na"
    },
    short: {
        finance: 'Finanse',
        stock: 'Magazyn'
    },
    onboarding: {
        welcome: 'Witaj!',
        step: {
            product: {
                totalBreakdown: 'Zestawienie całkowite',
                overallFulfilment: 'Całkowita realizacja',
                totalShippedQty: 'Całkowita wysłana ilość',
                totalReceivedQty: 'Całkowita otrzymana ilość',
                totalOrderedQty: 'Całkowita zamówiona ilość',
                totalShippedOrdered: 'Łącznie wysłano / zamówiono',
                totalReceivedOrdered: 'Łącznie otrzymano / zamówiono',
                viewQty: 'Zobacz ilość',
                fetchingQty: 'Pobieranie szczegółów ilości...',
                noStockInfo: 'Nie znaleziono informacji o stanie magazynowym',
                title: '65% Ukończone',
                description: 'Zostały tylko 2 kroki do wielkiego sukcesu!',
                Warehouse: "Magazyn",
            },
            stock: {
                title: '95% Prawie Gotowe!!',
                description: 'Został tylko jeden krok! Zakończ to teraz.'
            }
        },
        business: {
            title: 'Firma została pomyślnie utworzona!',
            description: 'Świetnie! Twoja firma została zarejestrowana'
        },
        product: {
            title: 'Dodaj swój pierwszy produkt',
            description: 'Dodaj produkt, aby rozpocząć ewidencję stanów magazynowych',
            Warehouse: "Magazyn",
        },
        stock: {
            title: 'Spróbuj dodać stan magazynowy',
            description: 'Rozpocznij ewidencję przyjścia i wyjścia towaru'
        },
        action: {
            add_business: {
                title: 'Utwórz firmę',
                description: 'Chcesz utworzyć nową firmę? Kliknij tutaj'
            },
            join_business: {
                title: 'Dołącz do firmy',
                description: 'Masz kod zaproszenia? Dołącz tutaj'
            }
        }
    },
    business: {
        title: 'Wybierz firmę, utwórz nową lub dołącz',
        add_business: {
            title: 'Utwórz nową firmę',
            name: 'Nazwa firmy',
            name_placeholder: 'Wpisz nazwę',
            category: 'Kategoria firmy',
            category_placeholder: 'Wybierz kategorię',
            button: 'Utwórz firmę'
        },
        edit_business: {
            title: 'Edytuj firmę'
        },
        join_business: {
            title: 'Dołącz do firmy',
            input_code: 'Wpisz kod zaproszenia poniżej:',
            field_placeholder: 'Kod zaproszenia',
            confirm_title: 'Dołącz',
            confirm_text: 'Staniesz się częścią zespołu w '
        },
        no_business: 'Brak dostępnych firm',
        create_or_join: 'Utwórz lub dołącz do firmy',
        message: {
            saved: 'Firma zapisana pomyślnie!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transakcje z ujemnym stanem magazynowym',
            isNegativeTransactionDisabledHint: 'Włączając tę opcję, możesz zapobiec transakcjom, które spowodowałyby ujemny stan magazynowy.',
            negativeStockError: 'Transakcje z ujemnym stanem magazynowym są wyłączone'
        }
    },
    profile: {
        edit_profile: {
            title: 'Edytuj profil',
            name: 'Imię i nazwisko',
            name_placeholder: 'Wpisz imię i nazwisko',
            email: 'Email',
            phone_number: 'Numer telefonu'
        },
        message: {
            required_name: 'Imię i nazwisko jest wymagane'
        }
    },
    product: {
        weightedAverageCost: 'Średni ważony koszt',
        weightedAverageValueLabel: 'Średnia ważona wartość',
        Product: 'Produkt',
        hideZeroStock: 'Ukryj zerowy stan',
        allVariants: 'Wszystkie warianty',
        choose_product: 'Wybierz produkt',
        choose_product_empty: 'Wybierz produkt i wpisz ilość',
        choose_product_empty_manufacturing: 'Wybierz produkt i wpisz ilość produkcyjną',
        search: {
            placeholder: 'Szukaj po nazwie / SKU',
            tooltip: 'Otwórz skaner',
            Warehouse: "Magazyn",
        },
        column: {
            image: 'Zdjęcie',
            name: 'Nazwa',
            price: 'Cena',
            buying_price: 'Cena kosztu',
            selling_price: 'Cena sprzedaży',
            sku: 'SKU',
            stock: 'Stan',
            quantity: 'Ilość',
            latest_stock: 'Pozostało',
            product_deleted: 'Produkt został usunięty',
            info_not_found: 'Informacje niedostępne',
            expired_date: 'Data ważności',
            invoice: 'Faktura'
        },
        no_product: 'Brak dostępnych produktów',
        no_product_subtitle: 'Dodaj swój pierwszy produkt, aby zacząć śledzić stany magazynowe, ceny i sprzedaż.',
        create_first_product: 'Utwórz swój pierwszy produkt',
        add_product: {
            sku: 'Kod produktu',
            sku_placeholder: 'Kod produktu. Przykład: 12345',
            name: 'Nazwa produktu',
            name_placeholder: 'Wpisz nazwę produktu',
            initial_stock: 'Stan początkowy',
            initial_stock_placeholder: 'Wpisz stan początkowy',
            buying_price: 'Cena kosztu',
            buying_price_placeholder: 'Wpisz cenę kosztu',
            selling_price: 'Cena sprzedaży',
            selling_price_placeholder: 'Wpisz cenę sprzedaży',
            category: 'Kategoria',
            category_placeholder: 'Wybierz kategorię',
            add_selling_price: 'Dodaj cenę hurtową',
            expired_date: 'Data ważności',
            expired_date_placeholder: 'Wybierz datę',
            description: 'Opis',
            description_placeholder: 'Wpisz opis',
            custom_label: 'Atrybut',
            custom_label_placeholder: 'Wpisz klucz',
            add_custom_label: 'Dodaj kolejny atrybut',
            Warehouse: "Magazyn",
        },
        customerLabel: {},
        choose_selling_price: 'Wybierz cenę sprzedaży',
        selling_price: 'Cena sprzedaży',
        total_product: 'Łączna liczba produktów',
        total_quantity: 'Całkowity stan magazynowy',
        total_buying_price: 'Całkowita cena kosztu',
        total_selling_price: 'Całkowita cena sprzedaży',
        message: {
            required_name: 'Nazwa produktu jest wymagana',
            required_sku: 'SKU jest wymagane',
            required_category: 'Kategoria jest wymagana',
            required_quantity: 'Stan początkowy jest wymagany',
            invalid_input_qty: 'Nieprawidłowa ilość',
            required_buying_price: 'Cena kosztu jest wymagana',
            required_selling_price: 'Cena sprzedaży jest wymagana',
            required_selling_price_name: 'Nazwa ceny sprzedaży jest wymagana',
            required_selling_price_price: 'Cena sprzedaży jest wymagana'
        },
        viewMore: 'Pokaż więcej',
        WarehouseDetails: 'Szczegóły magazynu',
        WarehouseName: 'Nazwa magazynu',
        AddWarehouse: 'Dodaj magazyn',
        WarehouseQty: 'Ilość w magazynie',
        Warehouse: 'Magazyn',
        Warehouses: 'Magazyny',
        Variants: 'Warianty',
        VariantName: 'Nazwa wariantu',
        productVariant: 'Warianty produktu',
        AddVariant: 'Dodaj wariant',
        TranferItem: 'Przenieś towary',
        AddUnit: 'Nowa jednostka',
        InitialStkWarehouse: 'Wymagany stan początkowy do dodania wariantów',
        InitialStockinwarehouse: 'Stan początkowy w magazynie',
        TotalQuantity: 'Całkowita ilość:',
        AddNote: 'Dodaj notatkę (cena kosztu)',
        AddNotetitle: 'Dodaj notatkę',
        VariantSuccessMessage: 'Wariant produktu zaktualizowany pomyślnie',
        Next: 'Dalej',
        Submit: 'Zatwierdź',
        INACTIVE: 'NIEAKTYWNY',
        errorone: 'Ups! Żądana ilość dla',
        errortwo: "nie zgadza się z ilościami przypisanymi do magazynów. Dostosuj ilość lub uzupełnij stan.",
        SelectWarehouse: 'Wybierz magazyn',
        SelectVariant: 'Wybierz wariant',
        Discount: 'Rabat',
        DiscountDetails: 'Szczegóły rabatu',
        FinalPrice: 'Cena końcowa',
        DiscountType: 'Typ rabatu',
        DiscountPer: 'Rabat %',
        DiscountValue: 'Wartość rabatu',
        Discountonprice: 'Rabat od ceny',
        Discountondiscount: 'Rabat od rabatu',
        AdditionalDiscount: 'Dodatkowy rabat',
        SellingPrice: 'Cena sprzedaży:',
        Save: 'Zapisz',
        OnOriginalPrice: 'Od ceny oryginalnej',
        OnDiscountedPrice: 'Od ceny po rabacie',
        columnSelector: {
            title: 'Pokaż kolumny',
            columnsButton: 'Kolumny',
            costPrice: 'Cena kosztu',
            sellingPrice: 'Cena sprzedaży',
            sku: 'SKU',
            warehouse: 'Magazyn',
            categories: 'Kategorie',
            safetyStock: 'Zapas bezpieczeństwa',
            attributes: 'Atrybuty',
            notes: 'Notatki',
            description: 'Opis',
            more: 'więcej',
            attribute: 'Atrybut',
            attributesTitle: 'Atrybuty',
            categoriesTitle: 'Kategorie',
            skuAliases: 'Aliasy SKU'
        }
    },
    note: {
        title: 'Notatki',
        add: 'Dodaj notatkę',
        no_note: 'Brak notatek'
    },
    settings: {
        category: 'Kategoria',
        language: 'Język',
        switch_business: 'Przełącz firmę',
        currencySelect: 'Waluta',
        languageChangeSuccess: 'Waluta zaktualizowana pomyślnie',
        languageChangeErrorMessage: 'Coś poszło nie tak podczas aktualizacji waluty',
        currencyAdded: 'Waluta dodana pomyślnie',
        currencyDelete: 'Waluta usunięta pomyślnie',
        Selectyourpreferredlanguage: "Wybierz preferowany język"
    },
    selectProductStock: 'Wybierz produkt',
    category: {
        category_list: {
            title: 'Kategorie produktów'
        },
        add_category: {
            button: 'Nowa kategoria',
            title: 'Dodaj nową kategorię'
        },
        edit_category: {
            title: 'Edytuj kategorię'
        },
        name: 'Nazwa kategorii',
        name_placeholder: 'Wpisz nazwę kategorii',
        no_category: 'Brak kategorii'
    },
    staff: {
        add: 'Dodaj pracownika',
        edit: 'Edytuj pracownika',
        access: {
            stock: 'Magazyn',
            add_product: 'Dodaj nowy produkt',
            edit_product: 'Edytuj produkt',
            delete_product: 'Usuń produkt',
            view_capital_price: 'Podgląd ceny kosztu',
            add_category: 'Dodaj nową kategorię',
            edit_category: 'Edytuj kategorię',
            delete_category: 'Usuń kategorię',
            add_supplier: 'Dodaj nowego dostawcę',
            edit_supplier: 'Edytuj dostawcę',
            delete_supplier: 'Usuń dostawcę',
            add_customer: 'Dodaj nowego klienta',
            edit_customer: 'Edytuj klienta',
            delete_customer: 'Usuń klienta',
            add_staff: 'Dodaj pracownika',
            edit_staff: 'Edytuj pracownika',
            delete_staff: 'Usuń pracownika',
            change_business_profile: 'Zmień profil firmy',
            access_by_product_category: 'Dostęp według kategorii produktu',
            no_category_message: 'Nie masz dodanych żadnych kategorii. Proszę dodać CategoryList.',
            expenses: 'Wydatki',
            view_expenses: 'Przeglądaj wydatki',
            add_expenses: 'Dodaj wydatek',
            edit_expenses: 'Edytuj wydatek',
            delete_expenses: 'Usuń wydatek',
            warehouse: 'Magazyn',
            add_new_warehouse: 'Dodaj nowy magazyn',
            edit_warehouse: 'Edytuj magazyn',
            delete_warehouse: 'Usuń magazyn',
            transfer_warehouse: 'Przenieś między magazynami',
            transfer_warehouse_approval: 'Zatwierdzenie przeniesienia między magazynami',
            access_by_warehouse: 'Dostęp według magazynu',
            no_warehouse_message: 'Nie masz dodanych żadnych magazynów. Proszę dodać WarehouseList.',
            purchase_order: 'Zamówienie zakupu',
            purchase_order_creation: 'Tworzenie zamówienia zakupu',
            purchase_order_edit: "Edycja zamówienia zakupu",
            purchase_order_cancel: "Anulowanie zamówienia zakupu",
            purchase_order_reopen: "Ponowne otwarcie zamówienia zakupu",
            purchase_order_receive: 'Odbiór zamówienia zakupu',
            sales_order: 'Zamówienie sprzedaży',
            sales_order_creation: 'Tworzenie zamówienia sprzedaży',
            sales_order_edit: "Edycja zamówienia sprzedaży",
            sales_order_cancel: "Anulowanie zamówienia sprzedaży",
            sales_order_reopen: "Ponowne otwarcie zamówienia sprzedaży",
            sales_order_receive: 'Wysyłka zamówienia sprzedaży',
            purchase_order_approval: 'Zatwierdzenie zamówienia zakupu',
            sales_order_approval: 'Zatwierdzenie zamówienia sprzedaży',
            can_do_available_warehouse: 'Dostępny magazyn',
            add_batch: 'Zatwierdzenie tworzenia partii',
            notification: 'Powiadomienie',
            staffNotification: 'Włącz powiadomienia',
            assignee: "Przypisany",
        },
        no_staff: 'Brak pracowników.'
    },
    code: {
        title: 'Nowy pracownik dodany!',
        subtitle: 'Udostępnij poniższy kod zaproszenia, aby dołączyć:',
        valid: 'Kod ważny tylko przez 48 godzin',
        share: 'Udostępnij na WhatsApp',
        copied: 'Skopiowano!',
        invalid: 'Nieprawidłowy kod!'
    },
    history: {
        no_history: 'Brak historii.',
        detail: {
            remove: 'Usuń historię',
            confirm: 'Ta operacja wpłynie na istniejący stan magazynowy, historię oraz raporty.'
        },
        no_history_selected: "Nie wybrano historii",
        select_history_hint: "Kliknij na pozycję z listy, aby zobaczyć szczegóły",
        select_from_left: "Wybierz z panelu po lewej stronie"
    },
    supplier: {
        add: {
            title: 'Dodaj dostawcę'
        },
        edit: {
            title: 'Edytuj dostawcę'
        },
        new: 'Nowy dostawca',
        no_supplier: 'Brak dostawców.',
        bank: {
            title: 'Dane bankowe'
        },
        note: 'Notatki',
        form: {
            name: {
                label: 'Nazwa dostawcy',
                placeholder: 'Wpisz nazwę dostawcy',
                placheolder_not_mandatory: 'Wpisz nazwę',
                error: {
                    required: 'Nazwa nie może być pusta'
                }
            },
            contact: {
                label: 'Numer kontaktowy',
                placeholder: '91934554432',
                error: {
                    required: 'Numer kontaktowy nie może być pusty',
                    invalid: 'Nieprawidłowy numer. Musi zawierać kod kraju'
                }
            },
            bank_name: {
                label: 'Nazwa banku',
                placeholder: 'Wpisz nazwę banku'
            },
            bank_account_name: {
                label: 'Nazwa posiadacza konta',
                placeholder: 'Wpisz nazwę posiadacza konta'
            },
            bank_account_number: {
                label: 'Numer konta',
                placeholder: 'Wpisz numer konta'
            },
            note: {
                label: 'Notatki',
                placeholder: 'Dodaj notatki'
            },
            openingBalance: {
                addBtn: 'Dodaj saldo początkowe',
                label: 'Saldo początkowe',
                placeholder: 'Wprowadź saldo początkowe',
                error: {
                    negative: 'Saldo początkowe nie może być ujemne'
                }
            }
        },
        choose: 'Wybierz dostawcę'
    },
    customer: {
        add: {
            title: 'Dodaj klienta'
        },
        edit: {
            title: 'Edytuj klienta'
        },
        new: 'Nowy klient',
        no_customer: 'Brak klientów.',
        note: 'Notatki',
        form: {
            name: {
                label: 'Nazwa klienta',
                placeholder: 'Wpisz nazwę klienta',
                placheolder_not_mandatory: 'Wpisz nazwę',
                error: {
                    required: 'Nazwa nie może być pusta'
                }
            },
            contact: {
                label: 'Numer kontaktowy',
                placeholder: '91934554432',
                error: {
                    required: 'Numer kontaktowy nie może być pusty',
                    invalid: 'Nieprawidłowy numer. Musi zawierać kod kraju'
                }
            },
            address: {
                label: 'Adres',
                placeholder: 'Wpisz adres'
            },
            note: {
                label: 'Notatki',
                placeholder: 'Dodaj notatki'
            },
            openingBalance: {
                addBtn: 'Dodaj saldo początkowe',
                label: 'Saldo początkowe',
                placeholder: 'Wprowadź saldo początkowe',
                error: {
                    negative: 'Saldo początkowe nie może być ujemne'
                }
            }
        },
        choose: 'Wybierz nabywcę',
        report: {
            view: 'Zobacz raport nabywcy',
            title: 'Raport klienta',
            no_report: 'Brak raportów dla nabywców w wybranym okresie.',
            column: {
                name: 'Nazwa',
                total_transaction: 'Liczba transakcji',
                total_amount: 'Całkowita sprzedaż',
                total_profit: 'Całkowity zysk'
            }
        }
    },
    confirm_delete: 'Czy na pewno chcesz usunąć te dane?',
    report: {
        title: 'Raport'
    },
    accounting: {
        download_pdf_report: 'Pobierz PDF',
        title: 'Księgowość',
        view_report: 'Zobacz raport finansowy',
        dashboard_title: 'Raport finansowy',
        stats: 'Statystyki',
        accounting_report: 'Raport księgowy',
        filter: {
            date: {
                placeholder: 'Wybierz datę',
                submit: 'Zastosuj',
                cancel: 'Resetuj filtr'
            },
            timeframe: {
                day: 'Dzienny',
                week: 'Tygodniowy',
                month: 'Miesięczny',
                year: 'Roczny'
            }
        },
        total_sales: 'Całkowita sprzedaż',
        total_purchases: 'Całkowite zakupy',
        total_profit: 'Całkowity zysk',
        total_expenses: 'Razem Wydatki',
        assets_value: 'Wartość bieżących aktywów',
        total_current_cogs_value: 'Całkowita bieżąca wartość COGS',
        current_asset_selling_price: 'Bieżąca cena sprzedaży aktywów',
        total_selling_price: 'Całkowita cena sprzedaży',
        table: {
            date: 'Data',
            sales: 'Sprzedaż',
            purchases: 'Zakupy',
            profit: 'Zysk',
            expenses: 'Wydatki'
        },
        no_data: 'Brak dostępnych danych.'
    },
    stock_report: {
        title: 'Raport stanów magazynowych',
        view: 'Zobacz raport magazynowy',
        no_report: 'Brak rekordów magazynowych dla wybranej daty lub pracownika.',
        allStaffPlaceHolder: 'Wszyscy pracownicy',
        column: {
            total_product: 'Aktualna liczba typów produktów',
            total_product_quantity: 'Całkowita liczba produktów'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Funkcja VIP',
            description:
                'Twój okres próbny dla tej funkcji dobiegł końca. Wesprzyj rozwój tej aplikacji lokalnej poprzez subskrypcję.',
            button: 'Zobacz plany subskrypcji'
        }
    },
    payment: {
        order: {
            title: 'Płatność'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Rozmiar obrazu nie może przekraczać 5MB!',
        failedMessage: 'Nie udało się przesłać obrazu produktu, spróbuj ponownie!',
        successUpload: 'Obraz został pomyślnie przesłany!',
        failedUIError: 'Nie udało się usunąć obrazu, spróbuj ponownie!',
        SuccessErrorImage: 'Obraz został pomyślnie usunięty!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nazwa produktu',
        categoryLabel: 'Kategoria',
        BuyingPriceLabel: 'Cena zakupu',
        SellingLabel: 'Cena sprzedaży',
        StockLabel: 'Stan magazynowy'
    },
    historyColumns: {
        Transactionlabel: 'Typ transakcji',
        Locallabel: 'Czas lokalny',
        Createdlabel: 'Utworzone przez',
        Vendorlabel: 'Nazwa dostawcy',
        Buyerlabel: 'Nazwa nabywcy',
        SKUlabel: 'SKU',
        Invoicelabel: 'Faktura',
        Productlabel: 'Nazwa produktu',
        Categorylabel: 'Kategoria',
        Buyinglabel: 'Cena zakupu',
        Sellinglabel: 'Cena sprzedaży',
        Initiallabel: 'Stan początkowy',
        Finallabel: 'Stan końcowy',
        Stocklabel: 'Zmiana stanu'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nazwa produktu',
        categoryLabel: 'Kategoria',
        buyingPriceLabel: 'Cena zakupu',
        sellingPriceLabel: 'Cena sprzedaży',
        stockInLabel: 'Przyjęcie',
        stockOutLabel: 'Wydanie',
        remainingStockLabel: 'Pozostały stan',
        openStockLabel: 'Stan początkowy',
        weightedAverageCost: 'Średni ważony koszt',
        weightedAverageCostLabel: 'Średni ważony koszt',
        weightedAverageValueLabel: 'Średnia ważona wartość'
    },
    accountingReportColumns: {
        dateRange: 'Zakres dat',
        reportingPeriod: 'Okres sprawozdawczy',
        reportGenerate: 'Generowanie raportu',
        warehouse: 'Magazyn',
        labelDate: 'Data',
        labelSales: 'Sprzedaż',
        labelPurchases: 'Zakupy',
        labelProfit: 'Zysk',
        labelExpenses: 'Wydatki',
        reportOptions: 'Kolumny raportu',
        summaryCards: 'Karty podsumowania',
        grandTotal: 'Suma całkowita',
        continued: 'cd.',
        subtotal: 'Suma częściowa',
        page: 'Strona'
    },
    customerReportColumns: {
        labelName: 'Nazwa',
        labelTotalTransaction: 'Liczba transakcji',
        labelTotalSales: 'Całkowita sprzedaż',
        labelTotalProfit: 'Całkowity zysk'
    },
    scannerDialog: {
        finished: 'Zakończono',
        reduce: 'Zmniejsz',
        successfull: 'Pomyślnie',
        searching: 'Wyszukiwanie...',
        title: 'Skaner aktywny. Skieruj na kod kreskowy!'
    },
    historyFilter: {
        SelectBuyer: 'Wybierz nabywcę',
        SelectVendor: 'Wybierz dostawcę'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stan: rosnąco',
        StockHightoLow: 'Stan: malejąco',
        AlphabetAZ: 'Alfabetycznie A-Z',
        AlphabetZA: 'Alfabetycznie Z-A'
    },
    minimizeTitle: 'Skaner aktywny',
    security_guarantee: {
        title: 'Gwarancja bezpieczeństwa danych'
    },
    invoice: {
        invoicePlaceholder: 'Numer faktury',
        invoiceTitle: 'Faktura',
        manageInvoiceAddress: 'Zarządzaj adresem faktury',
        selectOrManageAddresses: 'Wybierz, edytuj lub utwórz niestandardowe adresy faktur',
        useBusinessProfileAddress: 'Użyj adresu profilu firmy',
        noCustomAddressesFound: 'Nie dodano niestandardowych adresów',
        createCustomAddressDesc: 'Dodaj niestandardowe adresy rozliczeniowe lub oddziałów, aby drukować je na fakturach zamiast domyślnych danych profilu firmy.',
        defaultFromBusinessProfile: 'Domyślny z profilu firmy',
        editInvoiceAddress: 'Edytuj adres faktury',
        createNewInvoiceAddress: 'Utwórz nowy adres faktury',
        logoHeaderImage: 'Logo / Obraz nagłówka',
        deleteInvoiceAddress: 'Usuń adres faktury?',
        deleteAddressConfirmText: 'Czy na pewno chcesz usunąć ten adres faktury? Tej czynności nie można cofnąć.'
    },
    ManageInvoiceAddress: 'Zarządzaj adresem faktury',
    SelectOrManageAddresses: 'Wybierz, edytuj lub utwórz niestandardowe adresy faktur',
    UseBusinessProfileAddress: 'Użyj adresu profilu firmy',
    CreateNewAddress: 'Utwórz nowy adres',
    UpdatingList: 'Aktualizowanie listy...',
    NoCustomAddressesFound: 'Nie dodano niestandardowych adresów',
    CreateCustomAddressDesc: 'Dodaj niestandardowe adresy rozliczeniowe lub oddziałów, aby drukować je na fakturach zamiast domyślnych danych profilu firmy.',
    DefaultFromBusinessProfile: 'Domyślny z profilu firmy',
    EditInvoiceAddress: 'Edytuj adres faktury',
    CreateNewInvoiceAddress: 'Utwórz nowy adres faktury',
    LogoHeaderImage: 'Logo / Obraz nagłówka',
    UploadingImage: 'Przesyłanie obrazu...',
    UploadImage: 'Prześlij obraz',
    BusinessName: 'Nazwa firmy',
    AddressDetails: 'Szczegóły adresu',
    PhoneNumber: 'Numer telefonu',
    EmailAddress: 'Adres e-mail',
    DeleteInvoiceAddress: 'Usuń adres faktury?',
    DeleteAddressConfirmText: 'Czy na pewno chcesz usunąć ten adres faktury? Tej czynności nie można cofnąć.',

    stocklowreport: {
        no_stocklowreport_one: 'Brak produktów z ustawioną ilością zapasu bezpieczeństwa.',
        no_stocklowreport_two: 'Proszę dodać ilość zapasu bezpieczeństwa.',
        currentStock: 'Aktualny stan magazynowy',
        safetyStock: 'Zapas bezpieczeństwa',
        pricing: 'Cennik',
        costPrice: 'Cena zakupu',
        sellingPrice: 'Cena sprzedaży',
        productInfo: 'Informacje o produkcie',
        category: 'Kategoria',
        description: 'Opis',
        no_description: 'Nie dodano opisu',
        variants: 'Warianty',
        unitsOnHand: 'dostępne jednostki',
        minimumThreshold: 'minimalny próg',
        adjust: 'Dostosuj',
        all: 'Wszystkie',
        lowStock: 'Niski stan magazynowy',
        variantsDetails: 'Szczegóły wariantów',
        qty: 'Ilość',
        addSafetyStock: 'Dodaj zapas bezpieczeństwa',
        searchByNameSku: 'Szukaj według nazwy/SKU',
        safetyStockShort: 'B',
        warehouseSafetyStock: 'Zapas bezpieczeństwa magazynu'
    },
    low_alert_stock: 'Wpisz ilość zapasu bezpieczeństwa',
    lowStockAlertNotify: "Otrzymasz powiadomienie, gdy stan spadnie poniżej ustalonej ilości",
    applyButtonStockAlert: 'Zastosuj',
    cancelButtonStockAlert: 'Anuluj',
    searchProductLabel: 'Szukaj produktów...',
    successfullyAddedSafetyStock: 'Zapas bezpieczeństwa został pomyślnie zaktualizowany',
    safety_Stock: 'Zapas bezpieczeństwa',
    safety_stock_placeholder: 'Wpisz zapas bezpieczeństwa',
    lowStockDetailsInfo: {
        ProductCode: 'Kod produktu',
        SafetyStock: 'Zapas bezpieczeństwa',
        Stock: 'Stan magazynowy',
        CostPrice: 'Cena kosztu',
        SellingPrice: 'Cena sprzedaży',
        Category: 'Kategoria',
        Description: 'Opis',
        ExpirationDate: 'Data ważności'
    },
    CustomLang: {
        Attribute: 'Atrybut',
        AddAttribute: 'Dodaj atrybut',
        EditAttribute: 'Edytuj atrybut',
        CustomLabePlaceholder: 'Wpisz nazwę atrybutu',
        CustomLabePlaceholderSelect: 'Wybierz typ',
        AddMoreAttribute: 'Dodaj kolejny atrybut',
        ItemAttribute: 'Atrybut produktu',
        TableName: 'Nazwa',
        TableType: 'Typ',
        TableAction: 'Akcja',
        TableDelete: 'Usuń',
        TableEdit: 'Edytuj',
        deleteMessage: 'Atrybut usunięty pomyślnie',
        editSuccessMessage: 'Atrybut zaktualizowany pomyślnie',
        AddSuccessMessage: 'Atrybut dodany pomyślnie',
        AddAtt: 'Dodaj',
        EditAtt: 'Edytuj',
        SubmitAtt: 'Zapisywanie...'
    },
    Expenses: {
        ExpensesTitle: 'Wydatki',
        AddExpenses: 'Dodaj wydatek',
        ExpenseCategory: 'Kategoria wydatku',
        NoExpenseCategory: 'Brak kategorii wydatków',
        AddExpenseCategory: 'Dodaj kategorię wydatku',
        SelectExpenseCategory: 'Wybierz kategorię wydatku',
        NoExpenses: 'Brak wydatków',
        ExpensesSuccess: 'Wydatek dodany pomyślnie',
        ExpensesSuccessEdit: 'Wydatek zaktualizowany pomyślnie',
        ExpensesCategoryName: 'Nazwa kategorii wydatku',
        ExpensesSuccessDelete: 'Wydatek usunięty pomyślnie',
        AddNEC: 'Dodaj nową kategorię wydatku',
        NC: 'Nowa kategoria wydatku',
        EditNEC: "Edytuj kategorię wydatku"
    },
    Manufacturing: {
        ProducedProduct: "Wyprodukowany produkt",
        QuantityManufactured: "Ilość wyprodukowana",
        UnitCost: "Koszt jednostkowy",
        RawMaterialsTotal: "Suma surowców",
        TotalManufacturingCost: "Całkowity koszt produkcji",
        NoRawMaterialsConsumed: "Nie zużyto żadnych surowców.",
        CostBreakdown: "Podział kosztów",
        GeneratedBatch: "Wygenerowana partia",
        StoredBinLocation: "Lokalizacja przechowywania",
        NoManufacturingTransactionsFound: "Nie znaleziono transakcji produkcyjnych",
        AddManufacture: 'Dodaj szczegóły produkcji',
        Manufacturing: 'Produkcja',
        RawMaterials: 'Surowce',
        AdditonCosts: 'Koszty dodatkowe',
        RawMaterial: 'Surowiec',
        AdditonCost: 'Koszt dodatkowy',
        TotalCost: 'Koszt całkowity',
        AddRawMaterial: 'Dodaj surowiec dla',
        AddAdditonCost: 'Dodaj koszt dodatkowy dla',
        AddMore: 'Dodaj więcej',
        Add: 'Dodaj',
        Update: 'Aktualizuj',
        Updating: 'Zapisywanie...',
        ProductRequired: 'Produkt jest wymagany',
        QuantityRequired: 'Ilość jest wymagana',
        ChargeRequired: 'Opłata jest wymagana',
        EstimatedCostRequired: 'Szacowany koszt jest wymagany',
        PurchasePriceRequired: 'Cena zakupu jest wymagana',
        SelectCharge: 'Wybierz opłatę',
        EstimatedCost: 'Szacowany koszt',
        SelectProduct: 'Wybierz produkt',
        Quantity: 'Ilość',
        ManufactureDetails: 'Szczegóły produkcji',
        BuyingPrice: 'Cena zakupu',
        LabourCharge: 'Koszt robocizny',
        ElectricityCost: 'Koszt energii elektrycznej',
        PackagingCharge: 'Koszt opakowania',
        LogisticCost: 'Koszt logistyki',
        OtherCharges: 'Inne opłaty',
        Save: 'Zapisz szczegóły',
        PurchasePrice: 'Cena zakupu',
        Date: 'Data',
        For: 'Dla',
        PurchaseRate: 'Stawka zakupu (cena)',
        Scrolltoloadmore: 'Przewiń, aby załadować więcej...',
        Noproductsfound: 'Nie znaleziono produktów',
        ManufacturingQuantity: 'Ilość produkcji',
        ManufactureAddedSuccess: 'Szczegóły produkcji zaktualizowane pomyślnie'
    },
    Warehouses: {
        transferOrder: 'Magazyn',
        AddTransferOrder: 'Przenieś towary',
        NewWarehouse: 'Nowy magazyn',
        newHead: 'Zacznij zarządzać wieloma magazynami!',
        headTwo: 'Płynnie śledź i zarządzaj zapasami w wielu magazynach',
        EnableWarehouse: 'WŁĄCZ MAGAZYNY',
        EnableWarehouse2: 'Włącz magazyn',
        OrganizationPrimary: 'Magazyn główny organizacji',
        Edit: 'Edytuj',
        AreEnableWarehouse: 'Czy na pewno chcesz włączyć zarządzanie magazynami?',
        Confirm: 'Potwierdź',
        Cancel: 'Anuluj',
        WarehouseCreatedSuccessfully: 'Magazyn utworzony pomyślnie',
        MarkAsOP: "Oznacz jako magazyn główny organizacji",
        MarkAsInAct: 'Oznacz jako nieaktywny',
        MarkAsAct: 'Oznacz jako aktywny',
        MarkedAsInactive: 'Magazyn oznaczony jako nieaktywny pomyślnie',
        MarkedAsActive: 'Magazyn oznaczony jako aktywny pomyślnie',
        MarkedAsOP: 'Magazyn oznaczony jako główny pomyślnie',
        WareDeletedSuccess: 'Magazyn usunięty pomyślnie',
        SuccessfullyUpdatedWarehouse: 'Magazyn zaktualizowany pomyślnie',
        SuccessfullyCreatedWarehouse: 'Magazyn utworzony pomyślnie',
        EditWarehouse: 'Edytuj magazyn',
        AddWarehouse: 'Dodaj magazyn',
        WarehouseNameIsRequired: 'Nazwa magazynu jest wymagana',
        EnterWarehouseName: 'Wpisz nazwę magazynu',
        EnterEmail: 'Wpisz email',
        EnterPhoneNumber: 'Wpisz numer telefonu',
        Location: 'Lokalizacja...',
        name: 'Nazwa magazynu',
        email: 'Email',
        phoneNumber: 'Numer telefonu',
        location: 'Lokalizacja',
        ViewProducts: 'Zobacz produkty',
        PageTitle: 'Magazyn',
        noWarehouse: "Brak magazynów pasujących do wyszukiwania",
        ManageBin: "Zarządzaj binami"
    },
    Assets: {
        headerTitle: 'Środki trwałe',
        addAssetMessage: "Dodaj środki trwałe tutaj. Aby przypisać środek do pracownika, przejdź do profilu pracownika.",
        addAsset: 'Dodaj środek',
        editAsset: 'Edytuj środek',
        assetCode: 'Kod środka',
        assetName: 'Nazwa środka',
        assetCategory: 'Kategoria środka',
        assetType: 'Typ środka',
        serialNumber: 'Numer seryjny',
        location: 'Lokalizacja',
        condition: 'Stan',
        selectCondition: 'Wybierz stan',
        fair: 'Średni',
        good: 'Dobry',
        excellent: 'Doskonały',
        poor: 'Słaby',
        notes: 'Notatki',
        submit: 'Zapisz',
        submitting: 'Zapisywanie',
        noCategory: 'Brak kategorii',
        selectCategory: 'Wybierz kategorię',
        addAssetCat: 'Dodaj kategorię środka',
        addAssetCatName: 'Nazwa kategorii środka',
        edit: 'Edytuj',
        status: 'Status',
        createdAt: 'Utworzono',
        viewAsset: 'Zobacz środek',
        assignAsset: 'Przypisz środek',
        conditionRet: 'Stan (przy zwrocie)',
        searchSelectAssets: 'Wyszukaj / wybierz środek',
        assetAssigned: 'Środek przypisany pomyślnie',
        assetReturned: 'Środek zwrócony pomyślnie',
        selectAnAsset: 'Proszę wybrać środek',
        action: 'Akcja',
        noAssetAssigned: 'Brak przypisanych środków',
        reAssigned: 'Przypisz ponownie',
        assignedAssetsList: 'Lista przypisanych środków',
        viewHistory: 'Zobacz historię',
        history: 'Historia środka',
        loadingHistory: 'Ładowanie historii...',
        loadingMore: 'Ładowanie więcej...',
        dateTime: 'Data i godzina',
        staff: 'Pracownik',
        AssignedBy: 'Przypisano przez',
        assign: 'PRZYPISZ',
        return: 'ZWROĆ',
        unknown: 'NIEZNANY',
        noHistory: 'Brak historii dla tego środka.',
        enterReturnNote: 'Wpisz notatkę do zwrotu',
        returnNote: 'Notatka zwrotu',
        enterAssignNote: 'Wpisz notatkę do przypisania',
        assignNote: 'Notatka przypisania',
        AddNAC: "Dodaj nową kategorię środka",
        EditNAC: "Edytuj kategorię środka",
        others: "Inne"
    },
    LedgerTransaction: {
        ledgerDetails: 'Szczegóły konta',
        productName: 'Nazwa produktu',
        totalQty: 'Całkowita ilość',
        date: 'Data',
        receivedAmt: 'Otrzymana kwota',
        paid: 'Zapłacono',
        discount: 'Rabat',
        balance: 'Saldo',
        more: 'więcej',
        total: 'Razem',
        ledgerupdatedsuccessfully: 'Konto zaktualizowane pomyślnie',
        ledgeraddedsuccessfully: 'Konto dodane pomyślnie',
        viewLedger: 'Zobacz konto',
        edit: 'Edytuj',
        create: 'Utwórz',
        Recieved: 'Otrzymano [przyjęcie]',
        payMode: 'Forma płatności',
        Refno: 'Nr ref.'
    },
    ExtraField: {
        attachment: 'Załącznik',
        acceptOnlyImg: 'Akceptowane są tylko obrazy.',
        addAttribute: 'Dodaj atrybut',
        acceptImgAndDoc: 'Akceptowane są obrazy i dokumenty.'
    },
    phoneInvoiceDownload: {
        Variant: "Wariant",
        Warehouse: "Magazyn",
        Bin: "Bin",
        Batch: "Partia",
        Attributes: "Atrybuty"
    },
    ImportExcel: {
        ImportStockfromExcel: "Importuj stan z Excela",
        DragDrop: "Przeciągnij i upuść wypełniony plik Excel tutaj lub kliknij, aby przeglądać",
        DT: "Pobierz szablon",
        GB: "Wróć",
        Downloading: "Pobieranie...",
        ChangeFile: "Zmień plik",
        ReadingExcelfile: "Odczytywanie pliku Excel...",
        Processing: "Przetwarzanie...",
        submitUpdateStock: "Zapisz i zaktualizuj stan",
        downloadLatestTemplate: "Pobierz najnowszy szablon",
        loginRequired: "Wymagane logowanie"
    },
    stockForm: {
        recordPaymentNow: "Zarejestruj płatność teraz",
        recordPaymentDescCustomer: "Wprowadź kwotę zapłaconą przez klienta",
        recordPaymentDescSupplier: "Wprowadź kwotę zapłaconą przez dostawcę",
        managePayments: "Zarządzaj płatnościami",
        invoice: "Faktura",
        challan: "Challan",
        recordPayment: "Zarejestruj płatność",
        payableAmount: "Kwota do zapłaty",
        paidAmount: "Zapłacona kwota",
        paymentMethod: "Metoda płatności",
        paymentDate: "Data płatności",
        reference: "Referencja",
        billId: "Numer rachunku",
        importExcel: "Import z Excela",
        noThanks: "Nie, dziękuję",
        checkHistory: "Sprawdź historię",
        wantViewHistory: "Czy chcesz zobaczyć swoją historię?",
        enterPayable: 'Wpisz kwotę do zapłaty',
        enterPaid: 'Wpisz zapłaconą kwotę',
        selectPayment: "Wybierz metodę płatności",
        attachment: "Załącznik",
        note: "Notatka",
        serial_numbers: "Numery seryjne",
        enter_serials: "Wpisz numery seryjne",
        serial: "Numer seryjny",
        enter_serial_placeholder: "Wpisz numer seryjny...",
        added: "dodano",
        save_serials: "Zapisz numery seryjne",
        no_quantity: "Najpierw wpisz ilość"
    },
    HistoryEdit: {
        products: "Produkty",
        add_product: "Dodaj produkt",
        paidAmountInvalidMessage: 'Kwota zapłacona nie może być większa niż kwota do zapłaty',
        removingText: "Usunięcie tego produktu spowoduje cofnięcie zmian stanu magazynowego dokonanych w tej transakcji.",
        remove: "Usuń",
    },
    ExcelProduct: {
        uploadFile: "Prześlij plik",
        dragDrop: "Przeciągnij i upuść plik Excel lub kliknij, aby przesłać.",
        parsingFile: "Przetwarzanie pliku",
        fileSelected: "Plik wybrany",
        reviewImportedData: "Sprawdź zaimportowane dane poniżej. Kolumny zostały automatycznie dopasowane gdzie to możliwe.",
        changeFile: "Zmień plik",
        back: "Wstecz",
        invalidFileType: "Proszę przesłać poprawny plik Excel (.xlsx lub .xls)",
        parseExcelError: "Błąd parsowania Excela:",
        noData: "Przesłany plik Excel nie zawiera danych.",
        failedToRead: "Nie udało się odczytać pliku Excel. Spróbuj ponownie.",
        Nodata: "BRAK_DANYCH",
        unableToRead: "Nie można odczytać pliku.",
        buyingMustNumber: "Cena zakupu musi być liczbą",
        sellingMustNumber: "Cena sprzedaży musi być liczbą",
        mustBeNumber: "musi być liczbą",
        bulkUploadfailed: "Masowe wczytanie nie powiodło się",
        importFromExcel: "Import z Excela",
        generating: "Generowanie...",
        downloadTemplate: "Pobierz szablon",
        uploading: "Przesyłanie...",
        done: "Gotowe",
        requiredField: "{field} jest wymagane",
        bulkUpload: "Masowe wczytanie",
        duplicateSku: "Znaleziono duplikat SKU",
        uploadedSuccessfully: "Wszystkie produkty wczytane pomyślnie!",
        uploadCompleteIssues: "Wczytanie zakończone z problemami",
        uploaded_products: "Wczytano {count} produkt(ów).",
        failed_products: "{count} niepowodzeń.",
        failed_items: "Nieudane pozycje:"
    },
    ProductForm: {
        barcodeQuantity: "Wpisz ilość kodów kreskowych",
        baseUnit: "Jednostka bazowa (główna)",
        addSecondaryUnit: "Dodać jednostkę pomocniczą?",
        selectUnit: "Wybierz jednostkę",
        subUnitDetails: "Szczegóły jednostki pomocniczej",
        subUnit: "Jednostka pomocnicza",
        selectSubUnit: "Wybierz jednostkę pomocniczą",
        conversionRate: "Współczynnik przeliczeniowy",
        exampleLogic: "Przykład:",
        example: "Jeśli sprzedajesz długopisy w kartonach, ustaw jednostkę bazową jako Karton i dodaj jednostkę pomocniczą szt. z przelicznikiem 50. Oznacza to, że 1 karton zawiera 50 sztuk.",
        basePrice: "Cena bazowa",
    },
    barcode: {
        settings: 'Ustawienia kodów kreskowych',
        labelSize: 'Rozmiar etykiety',
        customSize: 'Rozmiar niestandardowy...',
        widthMm: 'Szerokość (mm)',
        heightMm: 'Wysokość (mm)',
        showPrice: 'Pokaż cenę sprzedaży na etykiecie',
        noPrices: 'Brak skonfigurowanych cen sprzedaży dla tego produktu.',
        preview: 'Podgląd',
        generate: 'Generuj',
        label: 'etykieta',
        singlePage: 'Jedna strona',
        downloadOptions: 'Opcje pobierania',
        chooseLayout: 'Wybierz układ kodów kreskowych',
        allInSinglePage: 'Wszystkie kody na jednej stronie.',
        allInA4Grid: 'Wszystkie na jednej stronie',
        allInA4GridSub: 'Układ wszystkich kodów w siatce A4',
        onePerPage: 'Jeden na stronę',
        onePerPageSub: 'Każdy kod na osobnej stronie etykiety'
    },
    Discount: {
        overallDiscount: "Rabat ogólny",
        final: 'Końcowa',
        balanceDue: "Saldo do zapłaty",
        tax: "Podatek",
    },
    TransferItem: {
        transferItem: 'Przeniesienie towarów',
        Date: 'Data',
        Reason: 'Powód',
        enterReason: "Wpisz powód",
        Name: 'Nazwa',
        QuantityTransfered: 'Przeniesiona ilość',
        SWarehouse: 'Magazyn źródłowy',
        SelectSWarehouse: 'Wybierz magazyn źródłowy',
        DWarehouse: 'Magazyn docelowy',
        SelectDWarehouse: 'Wybierz magazyn docelowy',
        CreatedBy: 'Utworzone przez',
        CreatedTime: 'Czas utworzenia',
        UpdatedTime: 'Czas aktualizacji',
        NoOrderFound: 'Nie znaleziono zamówień',
        New: 'Nowe',
        WarehouseItemTransfer: 'Przeniesienie towarów między magazynami',
        TotalTransfers: "Łączna liczba transferów",
        EnterReason: 'Wpisz powód',
        ItemDetails: 'Szczegóły towaru',
        CurrentAvailable: 'Aktualna dostępność',
        TransferQty: 'Ilość do przeniesienia',
        SStock: 'Stan źródłowy',
        DStock: 'Stan docelowy',
        addDescription: "Dodaj opis towaru",
        selectVariant: "Wybierz wariant",
        addNewRow: "Dodaj nowy wiersz",
        typeOrSelectItem: "Wpisz aby wyszukać",
        scrollToLoadMore: "Przewiń aby załadować więcej",
        noProductsFound: "Nie znaleziono produktów",
        selectWarehouse: "Wybierz magazyn",
        note: "Notatka",
    },
    Sku: {
        searchSelectProduct: "Wyszukaj / wybierz produkt",
        searchSelectSku: "Wyszukaj / wybierz SKU",
        noSkuFound: "Nie znaleziono SKU"
    },
    HistoryPage: {
        addFilter: "Dodaj filtr",
        filtersActive: "Wszystkie filtry są aktywne",
        noProducts: "Brak produktów",
        download: "Pobierz",
        recentlyUpdated: "Ostatnio zaktualizowane",
    },
    StockPage: {
        challanNumber: "Numer Challan",
        subTotal: "Suma częściowa",
        totalTaxes: "Razem i podatki",
        taxInclusive: "Z podatkiem",
        discountedValue: "Wartość po rabacie",
        taxValue: "Wartość podatku",
        totalAmount: "Kwota całkowita",
        close: "Zamknij",
        addTax: "Dodaj podatek",
        label: "Etykieta",
        enterLabel: "Wpisz etykietę",
        taxRate: "Stawka podatku",
        enterTaxRate: "Wpisz stawkę podatku",
        selectTaxRate: "Wybierz stawkę podatku",
        addNewTax: "Dodaj nową stawkę podatku",
        discountProducts: "Wartość rabatu (produkty)",
        taxProducts: "Wartość podatku (produkty)",
        clickAddPayment: "Kliknij aby dodać płatność",
        paidGreaterPayable: "Kwota zapłacona nie może być większa niż kwota do zapłaty",
        vendorCompulsory: 'Dostawca jest wymagany do zarejestrowania płatności',
        customerCompulsory: 'Klient jest wymagany do zarejestrowania płatności',
        updateInvoiceFormat: "Zaktualizuj format faktury",
        updateChallanFormat: "Zaktualizuj format challan",
        addPrefix: "Dodaj prefiks",
        prefix: "Prefiks"
    },
    EditHistoryPage: {
        search_by_notes: "Szukaj po notatkach",
        alertMessage: "Ta zmiana została zapisana tylko w historii i nie wpływa na bieżący stan magazynowy produktu.",
        paymentDetails: "Szczegóły płatności",
        units: "Jednostki",
        customLabels: "Niestandardowe etykiety",
        value: "Wartość",
        Order_Info: "Informacje o zamówieniu",
        percentage: "Procent",
        Stock_updates_on_submit: "Aktualizacja stanu przy zatwierdzeniu",
        Summary: "Podsumowanie"
    },
    historyCard: {
        paid: "ZAPŁACONO",
        partiallyPaid: "CZĘŚCIOWO ZAPŁACONO",
        billDate: "Data rachunku",
        productDetails: "Szczegóły produktu",
        paymentsHistory: "Historia płatności",
        updatePayment: "Aktualizuj płatność",
        discounts: "Rabaty",
        inclusive: "(w tym)",
        discountOverall: "Wartość rabatu (ogólna)",
        dueAmount: "Kwota należna",
        enterPaid: "Wpisz zapłaconą kwotę",
        enterReference: "Wpisz referencję",
        enterNote: "Wpisz notatkę",
        enterInvoice: "Wpisz numer faktury",
        enterChallan: "Wpisz numer challan",
        edit: "Edytowano"
    },
    printInvoice: {
        billTo: "Odbiorca",
        ref: "Nr ref.",
        mode: "Forma",
        date: "Data",
        amount: "Kwota",
        totalPaid: "Razem zapłacono",
        noImage: "Brak zdjęcia"
    },
    Contact: {
        supplier_required: "Dostawca jest wymagany przy przyjęciu towaru",
        customer_required: "Klient jest wymagany przy wydaniu towaru",
        key: "Klucz",
        editHistory: "Edytuj historię",
        loading: "Ładowanie..."
    },
    AW: {
        availablewarehouse: "Dostępny magazyn",
        visibilityManagement: 'Zarządzanie widocznością',
        availablewarehouses: "Dostępne magazyny",
        Active: "Aktywny",
        LWarehouse: "Ładowanie magazynów...",
        NWForthisProduct: "Nie znaleziono magazynów dla tego produktu.",
        of: "z",
        WarehouseAvailabilty: "Dostępność magazynowa",
    },
    Currency: {
        searchCurrency: "Wyszukaj waluty...",
        addCurrency: "Dodaj walutę",
        addNewCurrency: "Dodaj nową walutę",
        editCurrency: "Edytuj walutę",
        currencySymbol: "Symbol waluty",
        currencyName: "Nazwa waluty",
        enterCurrencySymbol: "Wpisz symbol waluty",
        enterCurrencyName: "Wpisz nazwę waluty"
    },
    NewReportLang: {
        DM: "Dzienne ruchy",
        WR: "Raport magazynowy",
        PDM: "Dzienne ruchy produktu",
        TBP: "Całkowita cena zakupu",
        TPQ: "Całkowita ilość produktów",
        TP: "Liczba produktów",
        CS: "Bieżący stan",
        IV: "Wartość zapasów",
        DA: "Średnia dzienna",
        TSI: "Całkowite przyjęcia",
        TSO: "Całkowite wydania",
        TOR: "Wskaźnik rotacji",
        Tv: "Wartość całkowita",
        AST: "Śledzenie aktywnych SKU",
        UT: "Śledzone jednostki",
        SL: "Poziom zapasu",
        Value: "Wartość",
        IO: "PRZYJĘCIE/WYDANIE",
        T: "Rotacja",
        unitsD: "Jednostek/dzień",
        Receivables: "Należności",
        Sort: "Sortuj",
        Sort_by: "Sortuj według",
        Units_available: "Dostępne jednostki",
        Units_unavailable: "Niedostępne jednostki",
        Current_assets: "Aktywa obrotowe",
        Search: "Szukaj",

        available: "Dostępne",
        assigned: "Przypisane",

        AYSWD: "Czy na pewno chcesz usunąć?",
        PTS: "Produkt przeniesiony pomyślnie",

        AUS: "Środki zaktualizowane pomyślnie",
        ACS: "Środki utworzone pomyślnie",
        VSP: "Pokaż cenę sprzedaży",
        HUS: "Historia zaktualizowana pomyślnie",
    },
    ReplacementReturn: {
        selectProduct: "Proszę wybrać produkt",
        selectReplacementProduct: 'Wybierz co najmniej jeden produkt zastępczy',
        validQuantity: 'Proszę wpisać prawidłową ilość zwrotu',
        replacedSuccessfully: "Produkt wymieniony pomyślnie",
        returnSuccessfully: "Produkt zwrócony pomyślnie",
        failedProcess: "Nie udało się przetworzyć. Spróbuj ponownie.",
        return: "Zwrot",
        replace: "Wymiana",
        typeSelectProduct: "Wpisz lub wybierz produkt...",
        returnQuantity: "Ilość zwrotu",
        enterQuantity: "Wpisz ilość",
        replacementDate: "Data wymiany",
        returnDate: "Data zwrotu",
        chooseCustomer: "Wybierz klienta",
        additionalNotes: "Dodaj dodatkowe notatki...",
        replacementProducts: "Produkty zastępcze",
        addProducts: "Dodaj więcej produktów",
        tapSelect: "Kliknij, aby wybrać z dostępnych produktów",
        currently: "Aktualnie",
        item: "produkt",
        items: "produkty",
        selected: "wybrano",
        selectedItems: "Wybrane produkty",
        hideDetails: 'Ukryj szczegóły',
        showDetails: 'Pokaż szczegóły',
        product: "produkt",
        priceLevel: "Wybierz poziom ceny",
        customPrice: "Wpisz niestandardową cenę",
        noReplaceHistory: "Nie znaleziono historii wymian",
        replaceReturn: "Wymiana i zwrot",
        replaceReturnHistory: "Historia wymian i zwrotów"
    },
    OtherComponent: {
        mfgHistoryTitle: "Historia produkcji",
        mfgHistoryDesc: "Śledź wyprodukowane produkty magazynowe",
        dailyOperation: "Codzienne operacje",
        freqUsed: "Często używane akcje do szybkiej aktualizacji rekordów",
        manageCategory: "Zarządzaj kategoriami",
        organizeCaterory: "Organizuj i zarządzaj kategoriami produktów, wydatków i środków trwałych",
        businessRecord: "Rejestry firmy",
        organizeRecord: "Organizuj i zarządzaj rejestrami swojej firmy",
        trackHistory: "Śledź historię",
        completeTracking: "Pełna historia do audytu i śledzenia",
        Verifyinventorycount: "Zweryfikuj stan magazynowy",
        Exchangerates: "Kursy wymiany",
        Productiontracking: "Śledzenie produkcji",
        Fixedassetregister: "Rejestr środków trwałych",
        Storagelocations: "Lokalizacje magazynowe",
        warehouseAvailability: 'Dostępność produktów na poziomie magazynu',
        Logreviewspend: "Rejestruj i przeglądaj wydatki",
        Productgroupings: "Grupowanie produktów",
        Classifyexpenditures: "Klasyfikuj wydatki",
        Assetclassification: "Klasyfikacja środków",
        Manageexchanges: "Zarządzaj wymianami",
        Returnauditlog: "Dziennik audytu zwrotów",
        Interlocationmoves: "Przeniesienia między lokalizacjami",
        Manageoperationscategoriesrecordsandhistory: "Zarządzaj operacjami, kategoriami, rekordami i historią"
    },
    no_permission_dialog: {
        title: 'Brak uprawnień',
        historyDescription: "Nie masz uprawnień do przeglądania Historii Transakcji. Skontaktuj się z administratorem.",
        replacementHistoryDescription: "Nie masz uprawnień do przeglądania Historii Wymian i Zwrotów. Skontaktuj się z administratorem.",
        transferHistoryDescription: "Nie masz uprawnień do przeglądania Historii Przeniesień Magazynowych. Skontaktuj się z administratorem."
    },
    OthersHistory: {
        title: "Zarządzaj historią",
        transferHistory: "Zarządzaj historią przeniesień",
        transactionHistory: "Zarządzaj historią transakcji",
        replacementHistory: "Zarządzaj historią wymian i zwrotów"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Przeglądaj i kupuj produkty udostępnione przez firmę.",
        description: "Przeglądaj produkty udostępnione przez firmę.",
        productsAvailable: "Dostępne produkty",
        noImageAvailable: "Brak zdjęcia",
        productDetails: 'Szczegóły produktu',
        inStock: "na stanie",
        availableVariants: "Dostępne warianty",
        options: "opcje",
        orders: "Zamówienia",

        searchProducts: "Szukaj produktów...",
        noProductsFound: "Nie znaleziono produktów",
        tryDifferentKeyword: "Spróbuj wyszukać inne słowo kluczowe",
        variants: "Warianty",
        stock: "Stan",
        cart: "Koszyk",
        products: "Produkty",
        viewCart: "Zobacz Koszyk",
        backToProducts: "Wróć do Produktów",
        yourCart: "Twój Koszyk",
        clear: "Wyczyść",
        cartEmpty: "Twój koszyk jest pusty",
        cartEmptyDesc: "Przeglądaj katalog i dodaj produkty, które chcesz zamówić.",
        browseProducts: "Przeglądaj Produkty",
        selectedItems: "Wybrane Produkty",
        itemInCart: "produkt w koszyku",
        itemsInCart: "produkty w koszyku",
        customerDeliveryDetails: "Dane Klienta i Dostawy",
        fullName: "Imię i Nazwisko",
        enterFullName: "Wprowadź imię i nazwisko",
        deliveryAddress: "Adres Dostawy",
        addressPlaceholder: "Ulica, budynek, miasto, kod pocztowy...",
        orderNote: "Notatka do Zamówienia (Opcjonalnie)",
        orderNotePlaceholder: "Specjalne instrukcje lub uwagi do dostawy...",
        paymentMode: "Metoda Płatności",
        subtotal: "Suma Częściowa",
        items: "produkty",
        totalAmount: "Kwota Całkowita",
        orderOnWhatsApp: "Zamów przez WhatsApp 📲",
        orderPlaced: "Zamówienie Złożone Pomyślnie! 🎉",
        orderPlacedDesc: "Twoje zamówienie zostało zarejestrowane, a WhatsApp został otwarty.",
        continueShopping: "Kontynuuj Zakupy 🛍️",
        cartEmptyTitle: "Koszyk Pusty",
        cartEmptyToast: "Dodaj produkty do koszyka przed realizacją.",
        incompleteTitle: "Niekompletne Dane",
        incompleteToast: "Wypełnij wszystkie wymagane pola przed złożeniem zamówienia.",
        nameRequired: "Imię i nazwisko jest wymagane",
        addressRequired: "Adres dostawy jest wymagany",
        catalogUnavailable: "Katalog Aktualnie Niedostępny",
        catalogUnavailableDesc: "Ten katalog nie jest aktywny. Skontaktuj się z firmą.",
        invalidCatalogLink: "Nieprawidłowy Link do Katalogu 🚫",
        invalidCatalogDesc: "Ta strona katalogu nie zawiera wymaganych informacji.",
        missing: "Brak",
        catalogSlug: "Slug Katalogu",
        goBackHome: "Wróć na Stronę Główną",
        inventoryManagement: "Zarządzanie Zapasami i Fakturowanie 🚀 Simply",
        enter: "Wprowadź",
        select: "Wybierz",
        // Catalog Order translations
        catalogOrders: 'Zamówienia katalogowe',
        pending: 'Oczekujące',
        converted: 'Przekształcone',
        cancelled: 'Anulowane',
        totalRevenue: 'Łączna wartość',
        totalCatalogOrders: 'Łączne zamówienia online',
        convertToSalesOrder: 'Przekształć w zamówienie sprzedaży',
        date: 'Data',
        status: 'Status',
        action: 'Akcja',
        searchOrders: 'Szukaj klienta lub telefonu...',
        noMatchingOrders: 'Nie znaleziono pasujących zamówień',
        noStatusOrders: 'Nie znaleziono zamówień {status}',
        tryDifferentSearch: 'Spróbuj wyszukać pod inną nazwą klienta lub numerem telefonu.',
        noOrdersWithStatus: 'Obecnie nie ma zamówień o statusie {status}.',
        noOrdersYet: 'Brak zamówień katalogowych',
        noOrdersDescription: 'Zamówienia złożone z Twojego katalogu online pojawią się tutaj.',
        guestCustomer: 'Klient gościnny',
        item: 'Pozycja',
        moreItems: '+{count} więcej',
        viewDetails: 'Zobacz szczegóły',
        viewSalesOrder: 'Zobacz zamówienie sprzedaży',
        cancelOrder: 'Anuluj zamówienie',
        confirmCancelTitle: 'Anulować zamówienie katalogowe?',
        confirmCancelOrder: 'Czy na pewno chcesz anulować to zamówienie? Tej czynności nie można cofnąć.',
        keepOrder: 'Nie, zachowaj zamówienie',
        confirmCancelAction: 'Tak, anuluj zamówienie',
        orderNotFound: 'Nie znaleziono zamówienia katalogowego',
        orderNotFoundDescription: 'Nie można znaleźć tego zamówienia lub możesz nie mieć uprawnień do jego wyświetlenia.',
        backToCatalogOrders: 'Wróć do zamówień katalogowych',
        placedOn: 'Złożono',
        totalItems: 'Łączna liczba pozycji',
        orderedProducts: 'Zamówione produkty',
        itemDetails: 'Szczegóły pozycji',
        quantity: 'Ilość',
        unitPrice: 'Cena jednostkowa',
        total: 'Razem',
        variant: 'Wariant',
        customerInformation: 'Informacje o kliencie',
        additionalFields: 'Dodatkowe pola',
        fields: 'pól',
    },
    stockNew: {
        Npay: "Nie dodano jeszcze żadnych produktów",
        emptydesc: "Wybierz produkt z katalogu i wpisz ilość przychodzącą, aby zaktualizować stan.",
        tipText: "Wskazówka: Możesz również przesłać plik Excel",
        OT: "Suma zamówienia",
        Collapse: "Zwiń"
    },
    deleteBulk: {
        Bulkoperation: "Operacja masowa",
        Applyproducts: "Zastosuj akcje do wielu produktów",
        Bulkupload: "Masowe wczytanie",
        ImportCSVfile: "Importuj produkty przez plik Excel lub CSV",
        or: "lub",
        Bulkdelete: "Masowe usuwanie",
        Permanentlyallproducts: "Trwale usuń wszystkie produkty",
        IrrText: "Masowe usuwanie jest nieodwracalne. Najpierw wyeksportuj kopię zapasową.",
        SeP: "Wybrane produkty",
        sP: "Wybierz produkt",
        DA: "Usuń wszystko",
        DP: "Usuń produkty",
        sL: "Zaznacz wszystkie",
        ASDE: "Czy na pewno chcesz usunąć wszystkie produkty oprócz",
        ASDAllP: "Czy na pewno chcesz usunąć wszystkie produkty?",
        ASD: "Czy na pewno chcesz usunąć",
        products: 'produkty',
        TACBU: "Tej akcji nie można cofnąć.",
        LP: "Ładowanie produktów...",
        FM: "Pobieranie więcej...",
        NPF: "Nie znaleziono produktów.",
        LMP: "Ładowanie więcej produktów...",
        BulkOperation: "Operacja masowa"
    },
    NewVariantModal: {
        Definevariantsassign: "Zdefiniuj warianty i przypisz ilości",
        Nothingallocated: "Nic nie przypisano",
        Overallocated: "Nadmiarowo przypisano",
        Fullyallocated: "W pełni przypisano",
        Overby: "Nadmiar o",
        Allvariantsneedaname: "Wszystkie warianty muszą mieć nazwę.",
        Reducequantities: "Zmniejsz ilości.",
        Overallocatedby: "Nadmiarowo przypisano o",
        Quantitiesmustmatchthetotalavailability: "Ilości muszą odpowiadać całkowitej dostępności.",
        Allocatequantitiesacrosswarehouses: "Przydziel ilości do magazynów",
        Notfullydistributed: "Nie w pełni rozdzielono:",
        remaining: "pozostało",
        Qty: "Ilość",
        Inactive: "Nieaktywny",
        left: "pozostało"
    },
    ProductFormNew: {
        BasicInfo: "Podstawowe informacje",
        ProductImage: "Zdjęcie produktu",
        Images: "Zdjęcia",
        Pricing: "Ceny",
        Everypriceneedsbothalabelandanamount: "Każda cena wymaga etykiety i kwoty",
        AddalabellikeWholesaleorRetailtoidentifythisprice: `Dodaj etykietę np. "Hurtowa" lub "Detaliczna", aby zidentyfikować tę cenę`,
        AddMultiplePrice: "Dodaj wiele cen",
        NoPhotosLetAiFind: "Brak zdjęć? Pozwól AI znaleźć zdjęcia produktu",
        AddProductImagesTitle: "Dodaj zdjęcia produktu",
        ChooseHowToAddPhotos: "Wybierz sposób dodawania zdjęć do tego produktu:",
        SearchWithAi: "Szukaj za pomocą AI",
        SearchWithAiDesc: "Automatycznie znajduj i wybieraj zdjęcia produktów za pomocą AI",
        FilesFileExplorer: "Pliki (Eksplorator plików)",
        FilesFileExplorerDesc: "Wybierz zdjęcia bezpośrednio z komputera",
        AiProductImageFinder: "Wyszukiwarka zdjęć produktów AI",
        AiProductImageFinderDesc: "Szukaj i wybieraj zdjęcia dla swojego produktu",
        TypeProductNamePlaceholder: "Wpisz nazwę produktu...",
        SearchForYourProduct: "Szukaj swojego produktu",
        SearchForYourProductHint: `Spróbuj nazwy marki lub produktu, np. "Kirkland Minoxidil"`,
        ImagesSelected: "wybranych zdjęć",
        AddSelected: "Dodaj wybrane"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Zdefiniuj nowe pole niestandardowe",
        AttributeName: "Nazwa atrybutu",
        DataType: "Typ danych",
        Noattributesfound: "Nie znaleziono atrybutów",
        ManageAttributes: "Zarządzaj atrybutami",
        Editordeleteexistingattributes: "Edytuj lub usuń istniejące atrybuty",
        UpdateAttribute: "Aktualizuj atrybut",
        Saving: "Zapisywanie..."
    },
    NewExpenses: {
        Noexpensesyet: 'Brak wydatków',
        Addyourfirstexpensetostarttrackingyourspending: "Dodaj pierwszy wydatek, aby rozpocząć śledzenie wydatków.",
        TOTALEXPENSES: "RAZEM WYDATKI",
        ENTRIES: "WPISY",
        BYCATEGORY: "WG KATEGORII",
        Nocategoriestodisplay: "Brak kategorii do wyświetlenia",
        DateanfTime: "Data i godzina"
    },
    PurchaseSales: {
        CancelOrder: "Anuluj zamówienie",
        ReopenOrder: "Otwórz ponownie zamówienie",
        Reopen: "Otwórz ponownie",
        ConfirmCancelOrder: "Czy na pewno chcesz anulować to zamówienie?",
        ConfirmReopenOrder: "Czy na pewno chcesz ponownie otworzyć to zamówienie?",
        OrderCancelledSuccessfully: "Zamówienie zostało pomyślnie anulowane.",
        OrderReopenedSuccessfully: "Zamówienie zostało pomyślnie ponownie otwarte.",
        CancelledBy: "Anulowane przez",
        Cancelled: "Anulowane",
        ConvertPriceBasedOnUnitConversion: "Przelicz cenę na podstawie przelicznika jednostek",
        MarkPaymentAsPending: "Oznacz płatność jako oczekującą",
        PendingReceivableDesc: "Kwota zarejestrowana jako należność. Zarejestruj płatność po otrzymaniu.",
        PendingPayableDesc: "Kwota zarejestrowana jako zobowiązanie. Zarejestruj płatność po dokonaniu.",
        SelectCustomerFirst: "Najpierw wybierz klienta",
        SelectSupplierFirst: "Najpierw wybierz dostawcę",
        SelectItemsFirst: "Najpierw wybierz co najmniej jedną pozycję",
        PaymentMarkedPendingDesc: "Płatność została oznaczona jako oczekująca. Odznacz 'Oznacz płatność jako oczekującą', aby zarejestrować płatność teraz.",
        SelectCustomerAndItemFirst: "Proszę najpierw wybrać klienta i co najmniej jeden element",
        SelectSupplierAndItemFirst: "Proszę najpierw wybrać dostawcę i co najmniej jeden element",
        SelectCustomerProductFirst: "Najpierw wybierz klienta i produkt",
        SelectSupplierProductFirst: "Najpierw wybierz dostawcę i produkt",
        Receivables: "Należności",
        Payables: "Zobowiązania",
        AccessDenied: "Dostęp zabroniony",
        YouDonthaeP: "Nie masz uprawnień do przeglądania tej strony. Jeśli uważasz, że to błąd, skontaktuj się z administratorem.",
        purchase: "Zakup",
        sales: "Sprzedaż",
        Areyousureyouwantto: "Czy na pewno chcesz",
        Thisactionwillupdateitsstatus: "Ta akcja zaktualizuje jego status.",
        ReasonOPtional: "Powód (opcjonalnie)",
        Enterareasonfor: "Wpisz powód dla",
        optionalDot: "(opcjonalnie)...",
        Reject: "Odrzuć",
        ConfirmOrder: "Potwierdź zamówienie",
        RejectOrder: "Odrzuć zamówienie",
        Previous: "Poprzednie",
        First: "Pierwsze",
        Order: "Zamówienie",
        Items: "Pozycje",
        Memo: "Notatka",
        SelectDateRange: "Wybierz zakres dat",
        List: "Lista",
        Board: "Tablica",
        View: "Widok",
        CreateSalesOrder: "Utwórz zamówienie sprzedaży",
        CreatePurchaseOrder: "Utwórz zamówienie zakupu",
        successfully: "pomyślnie",
        ManageAttachments: "Zarządzaj załącznikami",
        Stockoutitemsimmediatelyaftersaving: "Wydaj towary natychmiast po zapisaniu.",
        Stockinitemsimmediatelyaftersavingthisorder: "Przyjmij towary natychmiast po zapisaniu tego zamówienia.",
        ViewAttachments: "Zobacz załączniki",
        MemoAttachments: "Notatka i załączniki",
        ReceivedDate: "Data odbioru",
        ShippedDate: "Data wysyłki",
        OrderDate: "Data zamówienia",
        OrderDetails: "Szczegóły zamówienia",
        Subtotal: "Suma częściowa",
        OrderSummary: "Podsumowanie zamówienia",
        AddItem: "Dodaj pozycję",
        NewSalesOrder: "Nowe zamówienie sprzedaży",
        NewPurchaseOrder: "Nowe zamówienie zakupu",
        Createandmanageyour: "Twórz i zarządzaj swoimi",
        orders: "zamówieniami",
        Removeitem: "Usuń pozycję",
        UnitPrice: "Cena jednostkowa",
        PurchaseOrder: "Zamówienie zakupu",
        SalesOrder: "Zamówienie sprzedaży",
        PurchaseInvoice: "Faktura zakupu",
        SalesInvoice: "Faktura sprzedaży",
        PurchaseOrdernotfound: "Nie znaleziono zamówienia zakupu",
        Approve: "Zatwierdź",
        MarkasShipped: "Oznacz jako wysłane",
        MarkasReceived: "Oznacz jako odebrane",
        Marking: "Oznaczanie...",
        PartiallyShip: "Częściowo wyślij",
        PartiallyReceive: "Częściowo odbierz",
        Deleting: "Usuwanie...",
        Transaction: "Transakcja",
        Details: "Szczegóły",
        Item: "Pozycja",
        Received: "Odebrano",
        Shipped: "Wysłano",
        Ordered: "Zamówiono",
        units: "szt.",
        Overalldiscount: "Rabat ogólny",
        Transactions: "Transakcje",
        Notransactionsfound: "Nie znaleziono transakcji",
        OrderedQty: "Zamówiona ilość",
        Totalqty: "Całkowita ilość",
        StockingOut: "Wydawanie...",
        StockingIn: "Przyjmowanie...",
        thiorderUpdateStuau: "to zamówienie? Ta akcja zaktualizuje jego status.",
        TransactionDetails: "Szczegóły transakcji",
        Fetchingtransactiondetails: "Pobieranie szczegółów transakcji...",
        Nodetailsfoundforthistransaction: "Nie znaleziono szczegółów dla tej transakcji.",
        TotalBreakDown: "Rozbicie całkowite",
        ChangeAmount: "Kwota reszty",
        Attachments: "Załączniki",
        PoNumber: "Numer PO",
        SoNumber: "Numer SO",
        partner: "Partner",
        EditPurchase: "Edytuj zakup",
        EditSales: "Edytuj sprzedaż",
        PurchaseOrderDetails: "Szczegóły zamówienia zakupu",
        SalesOrderDetails: "Szczegóły zamówienia sprzedaży",
        OrderType: "Typ zamówienia",
        SelectOrderType: "Wybierz typ zamówienia",
        OrderTypePrepaid: "Przedpłata",
        OrderTypeCOD: "Płatność przy odbiorze",
        OrderTypePayLater: "Zapłać później",
        OrderTypePartialPayment: "Płatność częściowa",
        OrderTypeSubscription: "Subskrypcja",
        viewAvailabilty: 'Zobacz dostępność',
        NotReceived: "Nie otrzymano",
        NotShipped: "Nie wysłano",
        PartiallyReceived: "Częściowo otrzymano",
        PartiallyShipped: "Częściowo wysłano",
    },
    PriceReference: {
        HighPrice: "Najwyższa cena",
        LowPrice: "Najniższa cena",
        LastPrice: "Ostatnia cena",
        LastPurchasePrice: "Ostatnia cena zakupu",
        Nopricerecordsfound: "Nie znaleziono rekordów cen",
        BuyingPriceReference: "Historia cen zakupu",
        SellingPriceReference: "Historia cen sprzedaży",
        Viewstockinpricesfortheselectedvendorandproduct: "Zobacz ceny zakupu dla wybranego dostawcy i produktu",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Zobacz ceny sprzedaży dla wybranego klienta i produktu"
    },
    SubscriptionLocale: {
        premiumPlan: "Plan Premium",
        heading: "Podejmuj decyzje biznesowe",
        headingHighlight: "Oparte na danych",
        subtitle: "Odblokuj pełną moc analityki biznesowej — bez limitów, bez kompromisów.",

        choosePlan: "Wybierz plan",

        monthly: "Miesięcznie",
        annual: "Rocznie",
        oneTime: "Jednorazowo (Miesięcznie)",
        perMonth: "miesięcznie",
        perYear: "rocznie",
        bestValue: "Najlepsza wartość",

        continueWith: "Kontynuuj z",
        perMonthShort: "mies.",
        perYearShort: "rok",

        troubleWithSubscription: "Problemy z subskrypcją?",
        contactUs: "Skontaktuj się z nami",

        // Error messages
        paymentNotReady: "Płatność niegotowa",
        checkoutError: "BŁĄD PŁATNOŚCI",
        pricePreviewError: "BŁĄD PODGLĄDU CENY",

        // Popup
        subNotAvailable: "Subskrypcja niedostępna",
        subNotAvailableDesc: "Subskrypcje web nie są obecnie dostępne w Twoim kraju. Prosimy o subskrypcję przez aplikację mobilną lub bezpośredni kontakt z nami.",
    },
    SubscriptionLocale2: {
        GoPro: 'Przejdź na Pro',
        Makesmarterdecisionsbackedbyrealbusinessdata: "Podejmuj lepsze decyzje poparte rzeczywistymi danymi biznesowymi",
        ExploreProPlans: "Poznaj plany Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Możesz mieć wiele magazynów dla różnych lokalizacji fizycznych",
            "Każdy produkt śledzi stan niezależnie w każdym magazynie",
            'Użyj opcji "Przeniesienie magazynu", aby przenosić towary między lokalizacjami'
        ],
        NoWarehousesConfigured: "Brak skonfigurowanych magazynów",
        desc: "Zacznij od dodania magazynów (jeśli masz więcej niż jeden), a następnie dodaj produkty i rejestruj ruchy magazynowe.",
        WarehouseSetupTips: "Wskazówki konfiguracji magazynów",
        Noproductselected: "Nie wybrano produktu",
        Selectaproductfromthelefttoviewlowstockdetails: "Wybierz produkt z lewej listy, aby zobaczyć szczegóły niskiego stanu.",
        Chooseaproductfromthelist: "Wybierz produkt z listy",
        SelectProduct: "Wybierz produkt",
        SetQuantity: "Ustaw ilość",
        Showing: "Wyświetlanie",
        products: "produktów",
        Continue: "Kontynuuj",
        SaveSafetyStock: "Zapisz zapas bezpieczeństwa",
        SafetyStockSaved: "Zapas bezpieczeństwa zapisany!",
        hasbeensetto: "został ustawiony na",
        AddAnother: "Dodaj kolejny",
        Chooseaproduct: "Wybierz produkt",
        Step: "Krok",
        of: "z",
        Setsafetyquantity: "Ustaw ilość zapasu bezpieczeństwa",
        Complete: "Zakończ",
        SafetyStockQuantity: "Ilość zapasu bezpieczeństwa",
        Minimumunitsdropsbelowthisnumber: "Minimalna ilość, którą zawsze chcesz mieć na stanie. Alert zostanie wyzwolony, gdy stan spadnie poniżej tej liczby.",
        NewSafetyStock: "Nowy zapas bezpieczeństwa",
        SafetyNow: "Zapas teraz",
        SettingTo: "Ustawianie na",
        Change: "Zmień",
        sell: "sprzedaż",
        cost: "koszt",
        BulUD: "Masowe wczytanie / usuwanie"
    },
    SimplyLoginUI: {
        sslEncryption: "Szyfrowanie SSL 256-bit",
        dataPrivate: "Twoje dane są w 100% prywatne",
        worksOnDevices: "Działa na Androidzie i iPhonie",
        realTimeSync: "Synchronizacja w czasie rzeczywistym na wszystkich urządzeniach",
        cloudBackup: "Automatyczna kopia zapasowa w chmurze",
        availableOn: "Dostępne na Web, Android i iOS",
        tagline: "Twój magazyn,",
        taglineEm: "pięknie prosty.",
        subtitle: "Zaloguj się, aby zarządzać stanem, śledzić sprzedaż i prowadzić biznes — wszystko w jednym miejscu.",
        feature1Title: "Śledzenie stanu w czasie rzeczywistym",
        feature1Desc: "Zawsze wiesz dokładnie, co jest w każdym magazynie.",
        feature2Title: "Zamówienia sprzedaży i zakupu",
        feature2Desc: "Twórz faktury, zarządzaj dostawcami i śledź każdą transakcję.",
        feature3Title: "Inteligentne raporty",
        feature3Desc: "Raporty finansowe, magazynowe i dzienne ruchy w jednym miejscu.",
        feature4Title: "Synchronizacja w czasie rzeczywistym",
        feature4Desc: "Zmiany na telefonie natychmiast pojawiają się na webie — i odwrotnie.",
        rating1: "Ocena",
        rating2: "4.9/5",
        rating3: "od 10 000 firm hurtowych",
        brandName: "Simply",
        greeting: "Witaj ponownie! 👋",
        noPasswordNeeded: "Zaloguj się, aby zarządzać magazynem — Android, iPhone i web w pełnej synchronizacji.",
        badge1: "Zarządzanie magazynem",
        badge2: "Śledzenie sprzedaży",
        badge3: "Raporty",
        trustEncryptedTitle: "Zaszyfrowane",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "Prywatne",
        trustPrivateSub: "Tylko Twoje dane",
        trustBackedTitle: "Zabezpieczone",
        trustBackedSub: "Automatycznie codziennie",
        availableOnLabel: "DOSTĘPNE NA",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Wszystkie urządzenia synchronizują się natychmiast w czasie rzeczywistym",
        securityNote: "100% bezpieczne.",
        securityDesc: "Szyfrowanie bankowe chroni wszystkie Twoje dane. Odczytujemy tylko imię i email — nic więcej.",
        signingIn: "Logowanie...",
        termsPrefix: "Logując się zgadzasz się na",
        privacyPolicy: "Politykę Prywatności",
        and: "oraz",
        termsOfService: "Regulamin",
        google: "Zaloguj się przez Google",
    },
    BatchLocal: {
        BatchName: "Nazwa partii",
        EnterBatchName: "Wpisz nazwę partii",
        EnterNotes: "Wpisz notatki",
        ExpiredDate: "Data ważności",
        Selectexpireddate: "Wybierz datę ważności",
        BatchStatus: "Status partii",
        CreatedDate: "Data utworzenia",
        Areyousureyouwanttodeletethisbatch: "Czy na pewno chcesz usunąć tę partię?",
        Youhavencreatedanybatchforthisproduct: "Nie utworzyłeś jeszcze żadnej partii dla tego produktu.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Utwórz pierwszą partię, aby zacząć śledzenie zapasów według partii i terminu ważności.",
        Nobatchesyet: "Brak partii",
        Whatisbatchmanagement: "Czym jest zarządzanie partiami?",
        Howithelpsyourbusiness: "Jak pomaga Twojemu biznesowi",
        Trackbylotnumber: "Śledzenie według numeru partii",
        Trackbylotnumberdesc: "Grupuj zapasy według partii producenta, aby zawsze wiedzieć, z której partii pochodzi jednostka.",
        Expirydatecontrol: "Kontrola daty ważności",
        Expirydatecontroldesc: "Otrzymuj alerty przed upływem terminu ważności. Sprzedawaj starsze partie najpierw i automatycznie zmniejszaj straty.",
        Fulltraceability: "Pełna śledzalność",
        Fulltraceabilitydesc: "Zobacz dokładnie, która partia została użyta w każdej transakcji — idealne do audytów i wycofań.",
        Supplierwisestock: "Zapasy według dostawcy",
        Supplierwisestockdesc: "Oddziel zapasy od różnych dostawców nawet dla tego samego produktu.",
        Createyourfirstbatchbutton: "Utwórz pierwszą partię",
        Nomatchesfound: "Nie znaleziono pasujących partii",
        NomatchesfounddescBefore: "Nie znaleziono partii pasujących do ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Wyczyść wyszukiwanie",
        Nohistoryfoundthisbatch: "Brak historii dla tej partii",
        ComprehensiveDetails: "Szczegółowe informacje",
        History: "Historia",
        InBatch: "W partii",
        Noproductfoundinthisbatch: "Nie znaleziono produktów w tej partii",
        SelectBatch: "Wybierz partię",
        available: "dostępne",
        Searchbatches: "Szukaj partii...",
        Expires: "Ważność",
        Nobatchesfound: "Nie znaleziono partii",
        ManageBatches: "Zarządzaj partiami",
        Batchmanagement: "Zarządzanie partiami",
        Trackstockexpiry: "Śledź zapasy według partii i daty ważności",
        Turnoffbatchmanagement: "Wyłączyć zarządzanie partiami?",
        Yourgsafe: "Istniejące dane partii pozostaną bezpieczne.",
        Reenableanytimefrom: "Możesz włączyć ponownie w dowolnym momencie z",
        Otherstab: "zakładki Inne",
        AddBatch: "Dodaj partię",
        Total: "Razem",
        AssignProduct: "Przypisz produkt",
        EditProductAssignment: "Edytuj przypisanie produktu",
        AssignProducttoBatch: "Przypisz produkt do partii",
        Updateproductconfiguration: "Zaktualizuj konfigurację produktu",
        Step1of2: "Krok 1 z 2",
        Step2of2: "Krok 2 z 2",
        Selectvariantwarehouse: "Wybierz wariant i magazyn",
        SelectedProduct: "Wybrany produkt",
        AssignQuantity: "Przypisz ilość",
        BatchInfo: "Informacje o partii",
        Wecouldnthisproductidentifier: "Nie znaleziono partii powiązanych z tym identyfikatorem produktu.",
        NoActiveBatches: "Brak aktywnych partii",
        Endofresults: "Koniec wyników",
        Expiry: "Ważność",
        BatchManagementDescription: "Śledź zapasy według numeru partii i daty ważności. Zapewnia prawidłową kolejność LIFO / FEFO przy każdym wydaniu — bez ręcznego wyboru.",
        Expiryalerts: "Alerty o terminie ważności",
        Autonotifications: "Automatyczne powiadomienia",
        LIFOsorting: "Sortowanie LIFO / FEFO",
        Smartstockflow: "Inteligentny przepływ zapasów",
        Perout: "Wydanie per partia",
        Precisiontracking: "Precyzyjne śledzenie",
        NeedsReview: "Wymaga przeglądu",
        Pending: "Oczekuje",
        Rejected: "Odrzucono",
        Approved: "Zatwierdzono",
        WaitingForApproval: "Oczekuje na zatwierdzenie",
        WaitingForApprovalDesc: "Właściciel wkrótce przejrzy i zatwierdzi tę partię.",
        BatchRejected: "Partia odrzucona",
        BatchRejectedDesc: "Właściciel odrzucił tę partię.",
        Reason: "Powód",
        Approve: "Zatwierdź",
        Reject: "Odrzuć",
        ConfirmApproveTitle: "Zatwierdź partię",
        ConfirmRejectTitle: "Odrzuć partię",
        ConfirmApprovalAction: "Czy na pewno chcesz {action} tę partię? Ta akcja zmieni jej status.",
        ReasonOptional: "Powód (opcjonalnie)",
        EnterReasonPlaceholder: "Wpisz powód dla {action} (opcjonalnie)",
        Processing: "Przetwarzanie...",
        BatchActivatedSuccess: "Partia aktywowana pomyślnie",
        BatchDeactivatedSuccess: "Partia dezaktywowana pomyślnie",
        BatchDeletedSuccess: "Partia usunięta pomyślnie",
        BatchApprovedSuccess: "Partia zatwierdzona pomyślnie",
        BatchRejectedSuccess: "Partia odrzucona pomyślnie",
        SearchByBatchName: "Szukaj po nazwie partii...",
        YesTurnOff: "Tak, wyłącz",
        KeepItOn: "Zostaw włączone"
    },
    OverDas: {
        movestockbetweenlocations: "Przenieś zapasy",
        no_activity_yet: "Brak aktywności",
        no_activity_sub: "Sprzedaże, zakupy, ruchy magazynowe i zwroty pojawią się tutaj w czasie rzeczywistym.",
        make_first_sale: "Wykonaj pierwszą sprzedaż",
        add_stock: "Dodaj zapasy",
        all_stock_healthy: "Wszystkie stany magazynowe są w normie",
        all_stock_healthy_sub: "Żaden produkt nie ma niskiego stanu. Ustaw progi minimalne na produktach, aby otrzymywać alerty.",
        set_stock_thresholds: "Ustaw progi magazynowe",
        no_warehouses_setup: "Nie skonfigurowano magazynów",
        no_warehouses_setup_sub: "Dodaj magazyn, aby rozpocząć śledzenie lokalizacji zapasów.",
        add_first_warehouse: "Dodaj pierwszy magazyn",
        Customer: "Klienci",
        PurchasevsSales: "Zakupy vs Sprzedaż",
        Financialperformancechart: "Wykres wyników finansowych",
        QuickActions: "Szybkie akcje",
        Frequentlyused: "Często używane",
        Addinventory: "Dodaj zapasy",
        Dispatchitems: "Wydaj towary",
        Addorder: "Dodaj zamówienie",
        Newitem: "Nowy produkt",
        Inventoryaccess: "Dostęp do magazynu",
        Itemsneedingreorder: "Produkty wymagające uzupełnienia",
        Latesttransactions: "Ostatnie transakcje",
        Operationalsummary: "Podsumowanie operacyjne",
        ViewAll: "Zobacz wszystkie",
        Manage: "Zarządzaj",
        RecentActivity: "Ostatnia aktywność",
        LowStockAlerts: "Alerty niskiego stanu",
        Primary: "Główny",
        TotalWarehouses: "Liczba magazynów"
    },
    CategoryNewL: {
        TotalCategories: "Łączna liczba kategorii",
        lastaddedcategory: "ostatnio dodana kategoria",
        acrossalltypes: "wszystkich typów",
        MostRecent: "Najnowsze",
        YesD: "Tak, usuń",
        AllAssociated: "Wszystkie powiązane produkty mogą być dotknięte",
    },
    SerialLocal: {
        ShowOrHideFields: "Pokaż lub ukryj pola",
        ShowOrHideFieldsDesc: "Dotknij dowolnego elementu poniżej, aby go dodać lub usunąć z wydrukowanej faktury. Zmiany są stosowane natychmiast.",
        Manufacturesettings: "Ustawienia produkcji",
        Showbuyingprice: "cenę zakupu / koszt produktu",
        Showadditionalcost: "dodatkowy koszt",
        Costbreakdown: "Podział kosztów",
        Unitcost: "Koszt jednostkowy",
        Rawmaterialstotal: "Suma surowców",
        Confirmentry: "Potwierdź wpis",
        SaveSerials: "Zapisz numery seryjne",
        SerialNumber: "Numer seryjny",
        selected: "wybrano",
        added: "dodano",
        Serialnumbers: "Numery seryjne",
        ResetAll: "Resetuj wszystko",
        Wecouldnfindthis: "Nie znaleziono żadnych dostępnych numerów seryjnych dla tego produktu.",
        Nounitsfound: "Nie znaleziono jednostek",
        Searchingserialnumbers: "Wyszukiwanie numerów seryjnych...",
        Scanorenterstock: "Zeskanuj lub wpisz numery seryjne dla nowego towaru",
        Whataserialnumber: "Co to jest numer seryjny?",
        Auniqueidentifieryourinventorylifecycle: "Unikalny identyfikator każdej jednostki — pozwala śledzić każdy pojedynczy egzemplarz w cyklu życia zapasów.",
        Trackedstockout: "Śledzone wydanie",
        Chooseexactlyselected: "Wybierz dokładnie, które numery seryjne opuszczają magazyn. Pokazane są tylko numery wprowadzone dla tego produktu — ilość blokuje się po wybraniu ",
        SelectSerialstoout: " - Wybierz numery seryjne do wydania",
        Thisinvoicegeneratedusingwwwsimplstockco: "Ta faktura została wygenerowana za pomocą www.simplstock.co",
        AuthorizedSignature: "Podpis upoważnionej osoby",
        Invoicesettings: "Ustawienia faktury",
        Draw: "Narysuj",
        Taptoselectordeselectitems: "Kliknij, aby zaznaczyć lub odznaczyć pozycje",
        Thissignaturewillbeadded: "Ten podpis zostanie dodany na dole drukowanej faktury.",
        SignatureOptions: "Opcje podpisu",
        Upload: "Prześlij",
        DrawSignature: "Narysuj podpis",
        UploadSignature: "Prześlij podpis",
        Clear: "Wyczyść",
        ShowStaffName: "imię pracownika",
        ShowSKU: "SKU",
        ShowBusinessName: "nazwę firmy",
        ShowProductName: "nazwę produktu",
        ShowBusinessPhoneNumber: "numer telefonu",
        ShowBusinessEmail: "email",
        ShowBusinessAddress: "adres",
        ShowProductImage: "zdjęcie produktu",
        ShowPaymentDetails: "szczegóły płatności",
        ShowCategory: "kategorię",
        ShowVariant: "wariant",
        ShowWarehouse: "magazyn",
        ShowAttributes: "atrybuty",
        ShowQuantity: "ilość",
        ShowDiscount: "rabat",
        ShowTax: "podatek",
        ShowPrice: "cena",
        ShowTotalPrice: "cena całkowita produktu",
        ShowExpenses: "wydatki",
        ShowSignature: "podpis",
        ShowNote: "notatkę",
        ShowSerialNumber: "numer seryjny",
        Invoicesettingsapplied: "Ustawienia faktury zastosowane. Sprawdź fakturę pod kątem zmian.",
        EnterSerialNumber: "Wpisz numer seryjny",
        showAttachment: "załącznik"
    },
    FewLocal: {
        SelectBin: "Wybierz bin",
        Live: "Na żywo",
        Monitorinventorystocklevels: "Monitoruj zapasy, ruchy i poziomy magazynowe",
        StockControlCentre: "Centrum Kontroli Magazynu",
        Nochartdataavailable: "Brak danych do wykresu",
        Disabled: "Wyłączone",
        Enabled: "Włączone"
    },
    Bin: {
        Bin: "Bin",
        Add: "Dodaj",
        NoBinsAddedYet: "Nie dodano jeszcze binów",
        BinLocationsHelp: "Lokalizacje binów pomagają śledzić zapasy według dokładnej pozycji w magazynie — koniec z szukaniem.",
        NameThemByPosition: "Nazwij według pozycji:",
        AddBinLocation: "Dodaj lokalizację bin",
        BinLocations: "lokalizacje bin",
        BinNameRequired: "Nazwa bin jest wymagana",
        EditBin: "Edytuj bin",
        AddBin: "Dodaj bin",
        EnterBinName: "Nazwa bin",
        EnterBinNamePlaceholder: "Wpisz nazwę bin",
        BinStatus: "Status bin",
        BinNotes: "Notatki",
        EnterBinNotesPlaceholder: "Dodaj notatki...",
        ViewInventory: " Zobacz zapasy",
        Inventory: "Zapasy",
        TrymatchingadifferentSKUname: "Spróbuj innego SKU lub nazwy.",
        Thisbinlocationcurrentlyempty: "Ta lokalizacja bin jest obecnie pusta.",
        Loadingbins: "Ładowanie binów...",
        bins: "biny",
        ManageBin: "Zarządzaj binami",
        Print: "Drukuj",
        SBin: "Bin źródłowy",
        DBin: "Bin docelowy"
    },
    WarehouseExcel: {
        // Page Title & Description
        title: "Wczytaj magazyny i lokalizacje bin",
        description: "Wykonaj poniższe kroki, aby masowo utworzyć magazyny wraz z lokalizacjami bin za pomocą pliku Excel.",

        // Steps
        bulkUploadGuide: "Instrukcja masowego wczytania",
        step1: "Krok 1",
        downloadTemplate: "Pobierz szablon Excel",
        downloadTemplateDesc: "Pobierz oficjalny szablon z predefiniowanymi kolumnami. Nie zmieniaj ani nie usuwaj kolumn.",
        downloadTemplateBtn: "Pobierz szablon",

        step2: "Krok 2",
        fillExcelFile: "Wypełnij plik Excel",
        fillExcelDesc: "Każdy wiersz reprezentuje jeden magazyn. Wypełnij wszystkie kolumny — lokalizacje bin oddziel przecinkami w kolumnie <code>Bin Names</code>.",

        step3: "Krok 3",
        thingsToKeepInMind: "Co warto pamiętać",
        rulesDesc: "Przed wgraniem upewnij się, że plik spełnia poniższe zasady, aby uniknąć błędów.",

        step4: "Krok 4",
        uploadYourFile: "Wgraj plik",
        uploadDesc: "Po wypełnieniu wgraj plik poniżej. System automatycznie utworzy wszystkie magazyny i lokalizacje bin.",

        // Rules
        rules: [
            "Jeden wiersz = jeden magazyn",
            "Nazwy binów oddzielone przecinkami w jednej komórce",
            "Nie zmieniaj nazw kolumn",
            "Zduplikowane nazwy binów w jednym magazynie są pomijane",
            "Numer telefonu z kodem kraju",
            "Akceptowane tylko pliki .xlsx lub .xls"
        ],

        // Upload Box
        dropFileHere: "Upuść plik Excel tutaj",
        supports: "Obsługuje .xlsx i .xls — maks. 10 MB",
        chooseFileUpload: "Wybierz plik i wgraj",
        parsing: "Przetwarzanie pliku...",

        // Errors
        invalidFileType: "Nieprawidłowy typ pliku. Proszę wgrać plik Excel.",
        noData: "Nie znaleziono danych w pliku Excel",
        failedToRead: "Nie udało się odczytać pliku Excel",
        unableToRead: "Nie można odczytać pliku.",

        // Review Screen
        reviewTitle: "Sprawdź dane magazynów",
        reviewSubtitle: "Ostatnie sprawdzenie przed importem.",
        changeFile: "Zmień plik",
        rowsFound: "znalezionych wierszy",
        cancel: "Anuluj",
        finalizeImport: "Zakończ i importuj",
        importing: "Importowanie...",

        // Toast Messages
        success: "Sukces",
        allWarehouseUploadedSuccess: "Wszystkie magazyny wczytane pomyślnie",
        failed: "Niepowodzenie",
        bulkUploadFailed: "Masowe wczytanie nie powiodło się",
        error: "Błąd",

        // Bin Names Column Note
        binNamesNote: "W kolumnie <strong>Bin Names</strong> wpisz wszystkie lokalizacje bin dla magazynu w jednej komórce, oddzielone przecinkami — np. A1, A2, B1, REGAŁ-01. Nie twórz osobnych wierszy na każdy bin.",

        // Table Headers
        headers: {
            warehouseName: "Nazwa magazynu",
            email: "Email",
            phoneNumber: "Numer telefonu",
            location: "Lokalizacja",
            binNames: "Nazwy bin"
        }
    },
    CustomerExcel: {
        title: "Wczytaj klientów",
        description: "Wykonaj poniższe kroki, aby masowo dodać klientów za pomocą pliku Excel.",
        bulkUploadGuide: "Instrukcja masowego wczytania",
        step1: "Krok 1",
        downloadTemplate: "Pobierz szablon Excel",
        downloadTemplateDesc: "Pobierz oficjalny szablon z predefiniowanymi nagłówkami kolumn.",
        downloadTemplateBtn: "Pobierz szablon",
        step2: "Krok 2",
        fillExcelFile: "Wypełnij plik Excel",
        fillExcelDesc: "Każdy wiersz reprezentuje jednego klienta. Wypełnij wszystkie kolumny.",
        step3: "Krok 3",
        thingsToKeepInMind: "Co warto pamiętać",
        rulesDesc: "Przed wgraniem upewnij się, że plik spełnia poniższe zasady, aby uniknąć błędów.",
        step4: "Krok 4",
        uploadYourFile: "Wgraj plik",
        uploadDesc: "Po wypełnieniu wgraj plik poniżej. System automatycznie utworzy wszystkich klientów.",
        rules: [
            "Jeden wiersz = jeden klient",
            "Nie zmieniaj nazw kolumn",
            "Numer kontaktowy z kodem kraju",
            "Akceptowane tylko pliki .xlsx lub .xls"
        ],
        dropFileHere: "Upuść plik Excel tutaj",
        supports: "Obsługuje .xlsx i .xls — maks. 10 MB",
        chooseFileUpload: "Wybierz plik i wgraj",
        parsing: "Przetwarzanie pliku...",
        invalidFileType: "Nieprawidłowy typ pliku. Proszę wgrać plik Excel.",
        noData: "Nie znaleziono danych w pliku Excel",
        failedToRead: "Nie udało się odczytać pliku Excel",
        unableToRead: "Nie można odczytać pliku.",
        reviewTitle: "Sprawdź dane klientów",
        reviewSubtitle: "Ostatnie sprawdzenie przed importem do firmy.",
        changeFile: "Zmień plik",
        rowsFound: "znalezionych wierszy",
        cancel: "Anuluj",
        finalizeImport: "Zakończ i importuj",
        importing: "Importowanie...",
        success: "Sukces",
        allCustomerUploadedSuccess: "Wszyscy klienci zostali wczytani pomyślnie",
        failed: "Niepowodzenie",
        bulkUploadFailed: "Masowe wczytanie nie powiodło się",
        error: "Błąd",
        headers: {
            customerName: "Nazwa klienta",
            phoneNumber: "Kontakt",
            address: "Adres",
            note: "Notatka"
        }
    },
    SupplierExcel: {
        title: "Wczytaj dostawców",
        description: "Wykonaj poniższe kroki, aby masowo dodać dostawców za pomocą pliku Excel.",
        bulkUploadGuide: "Instrukcja masowego wczytania",
        step1: "Krok 1",
        downloadTemplate: "Pobierz szablon Excel",
        downloadTemplateDesc: "Pobierz oficjalny szablon z predefiniowanymi nagłówkami kolumn.",
        downloadTemplateBtn: "Pobierz szablon",
        step2: "Krok 2",
        fillExcelFile: "Wypełnij plik Excel",
        fillExcelDesc: "Każdy wiersz reprezentuje jednego dostawcę. Wypełnij wszystkie kolumny.",
        step3: "Krok 3",
        thingsToKeepInMind: "Co warto pamiętać",
        rulesDesc: "Przed wgraniem upewnij się, że plik spełnia poniższe zasady, aby uniknąć błędów.",
        step4: "Krok 4",
        uploadYourFile: "Wgraj plik",
        uploadDesc: "Po wypełnieniu wgraj plik poniżej. System automatycznie utworzy wszystkich dostawców.",
        rules: [
            "Jeden wiersz = jeden dostawca",
            "Nie zmieniaj nazw kolumn",
            "Numer kontaktowy z kodem kraju",
            "Akceptowane tylko pliki .xlsx lub .xls"
        ],
        dropFileHere: "Upuść plik Excel tutaj",
        supports: "Obsługuje .xlsx i .xls — maks. 10 MB",
        chooseFileUpload: "Wybierz plik i wgraj",
        parsing: "Przetwarzanie pliku...",
        invalidFileType: "Nieprawidłowy typ pliku. Proszę wgrać plik Excel.",
        noData: "Nie znaleziono danych w pliku Excel",
        failedToRead: "Nie udało się odczytać pliku Excel",
        unableToRead: "Nie można odczytać pliku.",
        reviewTitle: "Sprawdź dane dostawców",
        reviewSubtitle: "Ostatnie sprawdzenie przed importem do firmy.",
        changeFile: "Zmień plik",
        rowsFound: "znalezionych wierszy",
        cancel: "Anuluj",
        finalizeImport: "Zakończ i importuj",
        importing: "Importowanie...",
        success: "Sukces",
        allSupplierUploadedSuccess: "Wszyscy dostawcy zostali wczytani pomyślnie",
        failed: "Niepowodzenie",
        bulkUploadFailed: "Masowe wczytanie nie powiodło się",
        error: "Błąd",
        headers: {
            supplierName: "Nazwa dostawcy",
            phoneNumber: "Kontakt",
            bankName: "Nazwa banku",
            accountHolderName: "Nazwa posiadacza konta",
            accountNumber: "Numer konta",
            note: "Notatka"
        }
    },
    VariantTemplate: {
        VariantTemplates: "Szablony wariantów",
        Managereusablevariantpatterns: "Zarządzaj wielokrotnie używanymi szablonami wariantów",
        BinTransferHistory: "Historia przeniesień bin",
        Trackmovementsacrossbins: "Śledź ruchy między binami",
        SerialNumberHistory: "Historia numerów seryjnych",
        Trackproductserialnumberactivity: "Śledź aktywność numerów seryjnych produktów",
        Period: "Okres",
        Nohistoryfound: "Nie znaleziono historii",
        Searchserialnumbers: "Szukaj numerów seryjnych...",
        SerialNumbersHistory: "Historia numerów seryjnych",
        Serialnumberhistoryglance: "Historia numerów seryjnych w pigułce.",
        Noserialnumbersfound: "Nie znaleziono numerów seryjnych",
        Noactivityhistoryfound: "Nie znaleziono historii aktywności",
        Statussetto: "Status zmieniony na",
        Timeline: "Oś czasu",
        Managereusableproductvariantpatterns: "Zarządzaj wielokrotnie używanymi szablonami wariantów produktów.",
        DeleteTemplate: "Usuń szablon",
        Areyousureyouwanttemplate: "Czy na pewno chcesz usunąć ten szablon?",
        CreateNewTemplate: "Utwórz nowy szablon",
        CreateTemplate: "Utwórz szablon",
        EditTemplate: "Edytuj szablon",
        UnlimitedTemplates: "Nieograniczona liczba szablonów",
        CreateAsManyTemplates: "Twórz tyle szablonów, ile potrzebujesz — Odzież, Obuwie, Elektronika i więcej.",
        PickWhileAddingProduct: "Wybieraj podczas dodawania produktu",
        OpenTemplateLibrary: "Otwórz bibliotekę szablonów i wybierz nazwy wariantów w kilka sekund.",
        MixFromMultipleTemplates: "Łącz z wielu szablonów",
        SelectFromMultipleTemplates: "Wybieraj nazwy wariantów z więcej niż jednego szablonu dla jednego produktu — pełna elastyczność.",
        EditAnytime: "Edytuj w dowolnym momencie",
        RenameTemplatesAnytime: "Zmieniaj nazwy szablonów, dodawaj lub usuwaj warianty, gdy zmienia się Twój katalog.",
        StayConsistent: "Zachowaj spójność",
        SameVariantNamesAcrossAll: "Te same nazwy wariantów we wszystkich produktach. Bez literówek, duplikatów i zgadywania.",
        BuildOnceUseEverywhere: "Utwórz raz — używaj wszędzie",
        StopReEnteringVariantNames: "Przestań wpisywać te same nazwy wariantów dla każdego produktu. Utwórz szablon, przypisz do niego warianty i używaj go natychmiast.",
        Updateexistingvariantcombinations: "Aktualizuj istniejące kombinacje wariantów",
        Definenewvariantcombinations: "Definiuj nowe kombinacje wariantów",
        TemplateName: "Nazwa szablonu",
        AddVariantOptions: "Dodaj opcje wariantów",
        SmallMedium: "np. Mały, Średni...",
        VariantsList: "Lista wariantów",
        Nooptionsaddedyet: "Nie dodano jeszcze opcji",
        SaveTemplate: "Zapisz szablon",
        egSizesColorsetc: "np. Rozmiary T-shirtów, Kolory itp.",
        Pleaseentertemplatename: "Proszę wpisać nazwę szablonu",
        Pleaseaddatleastonevariantoption: "Proszę dodać co najmniej jedną opcję wariantu",
        Templateupdatedsuccessfully: "Szablon zaktualizowany pomyślnie",
        Templatecreatedsuccessfully: "Szablon utworzony pomyślnie",
        Failedtosavetemplate: "Nie udało się zapisać szablonu",
        Transfer: "Przenieś",
        Editassignment: "Edytuj przypisanie",
        Updateproductdetailsinbin: "Zaktualizuj szczegóły produktu w binie",
        Editinginbin: "Edytowanie w binie",
        ConfirmUpdate: "Potwierdź aktualizację",
        ConfirmAssign: "Potwierdź przypisanie",
        Assignanotherproduct: "Przypisz kolejny produkt",
        TransferBin: "Przenieś bin",
        SourceBin: "Bin źródłowy",
        DestinationBin: "Bin docelowy",
        SelectSourceBin: "Wybierz bin źródłowy",
        SelectDestinationBin: "Wybierz bin docelowy",
        Unit: "Jednostka",
        ManageVariant: "Zarządzaj wariantami",
        CreateSKUvariationsyourproduct: "Twórz warianty SKU dla swojego produktu",
        Assigningvariationsto: "Przypisywanie wariantów do",
        Novariantsaddedyet: "Nie dodano jeszcze wariantów",
        AddedVariants: "Dodane warianty",
        AddVariantsfromTemplate: "Dodaj warianty z szablonu",
        Pickatemplateandselectvariantnames: "Wybierz szablon i nazwy wariantów",
        ChooseaTemplate: "Wybierz szablon",
        Selectvariantnamestoadd: "Wybierz nazwy wariantów do dodania",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Wybierz szablon, z którego chcesz pobrać nazwy wariantów. Możesz dodawać z wielu.",
        Loadingtemplates: "Ładowanie szablonów...",
        Backtotemplates: "Wróć do szablonów",
        Selectallindividualadd: "Zaznacz wszystkie lub pojedyncze nazwy wariantów do dodania.",
        VariantNames: "Nazwy wariantów",
        MediaDescription: "Multimedia i opis",
        Addattachmentsandproductnotes: "Dodaj załączniki i notatki produktu",
        ProductMedia: "Multimedia produktu"
    },
    AddProductGuide: {
        title: "Dodaj stan początkowy po zapisaniu",
        description:
            "Produkty nie mają tutaj pola ilości. Po zapisaniu użyj opcji 'Przyjęcie towaru', aby wprowadzić stan początkowy — z pełną kontrolą nad lokalizacją i śledzeniem.",

        steps: {
            quantity: {
                title: "Ilość",
                sub: "Ustaw stan początkowy",
            },
            binLocation: {
                title: "Lokalizacja bin",
                sub: "Alejka, regał, półka — np. A-01-03",
            },
            serialNumbers: {
                title: "Numery seryjne",
                sub: "Śledź każdą sztukę indywidualnie",
            },
            warehouse: {
                title: "Magazyn",
                sub: "W którym magazynie jest przechowywany",
            },
            batchExpiry: {
                title: "Partia / termin ważności",
                sub: "Grupuj zapasy według numeru partii",
            },
        },

        actions: {
            close: "Zamknij",
        },
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Nie znaleziono zleceń przeniesienia",
        Itemshistory: "Towary przenoszone między magazynami będą tutaj widoczne do śledzenia i historii.",
        CreateTransfer: "Utwórz przeniesienie"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Kliknij produkt, aby wyprodukować",
        Selectproductfrombelow: "Wybierz produkt z listy poniżej",
        SetupANewProduct: 'Skonfiguruj nowy produkt',
        DefineAProductAdditsrawmaterial: "Zdefiniuj produkt i dodaj jego surowce",
        ManufacturingSetup: "Konfiguracja produkcji",
        Pickproducttodefineitsproductiondetails: "Wybierz produkt, aby zdefiniować szczegóły produkcji",
        ConfigureManufacturing: "Skonfiguruj produkcję",
        SelectRawMaterial: "Wybierz surowiec",
        NoRawMaterials: "Brak surowców",
        Definecomponentsneededtoproduct: "Zdefiniuj komponenty potrzebne do wyprodukowania tego produktu.",
        NoAdditionalCosts: "Brak kosztów dodatkowych",
        Addlaboroverheadlogisticalcharges: "Dodaj koszty robocizny, narzutu lub logistyki.",
        AddAdditionalCost: "Dodaj koszt dodatkowy",
        AddCost: "Dodaj koszt",
        TotalPrice: "Cena całkowita",
        SelectCharges: "Wybierz opłaty",
        EnterEstimatedCost: "Wpisz szacowany koszt",
        QtyRequried: "Wymagana ilość",
        Manufacturing: "Produkcja",
        Outputfinishedgoodsdestination: "Wyjście — miejsce docelowe wyrobu gotowego",
        Manufacturingquantity: "Ilość produkcji",
        Storefinishedgoodsat: "Przechowuj wyroby gotowe w",
        Rawmaterials: "Surowce",
        StockSelection: "Wybór zapasów",
        AdditionalCosts: "Koszty dodatkowe",
        Quantityconsume: "Ilość do zużycia",
        Totalmanufacturingcost: "Całkowity koszt produkcji",
        Sumofrawmaterialcosts: "Suma kosztów wszystkich surowców",
        CustomManufacturingCharge: "Niestandardowa opłata produkcyjna",
        Addextralikelaboroverheadrepairs: "Dodaj dodatkowe koszty, np. robociznę, narzut lub naprawy.",
        CalculatedTotal: "Obliczona suma",
        AddRawMaterial: "Dodaj surowiec",
        ConfigureRawMaterial: "Skonfiguruj surowiec",
        Thisoutputunit: "To jest bazowa ilość wymagana na jednostkę wyjściową.",
        ChangeProduct: "Zmień produkt",
        AddtoList: " Dodaj do listy",
        Manufacture: "Wyprodukuj",
        EditDeleteHistory: "Edytuj/Usuń historię",
        ManageOrder: "Zarządzaj zamówieniem",
        ManageBatch: "Zarządzaj partią",
        Paymentnotavailablehere: "Płatność nie jest dostępna tutaj",
        Thisrecordisanorderorderitself: "Ten rekord pochodzi z zamówienia. Płatność można zarejestrować tylko z poziomu zamówienia.",
        Torecorpaymenttheorderthethere: "Aby zarejestrować płatność, przejdź do powiązanego zamówienia i użyj opcji <b>Zarejestruj płatność</b>.",
        GotoOrder: "Przejdź do zamówienia"
    },
    ReplaceReturnLocal: {
        BuyingPrice: "Cena zakupu",
        SellingPrice: "Cena sprzedaży",
        ReplacedWith: "Wymieniono na",
        Noreplacementhistoryfound: "Nie znaleziono historii wymian",
        Noreturnhistoryfound: "Nie znaleziono historii zwrotów",
        Productbeingreturned: "Zwracany produkt",
        Required: "Wymagane",
        Selectreturnedproduct: "Wybierz zwracany produkt",
        Searchnamescanbarcode: "Szukaj po nazwie, SKU lub zeskanuj kod kreskowy",
        Browse: "Przeglądaj",
        Stockhandling: "Sposób przyjęcia zwrotu",
        Stockinreturnedproduct: "Przyjmij zwrócony produkt do magazynu",
        Ontoinventory: "Włącz — zwrócony towar zostanie dodany z powrotem do magazynu",
        Offreturnedonly: "Wyłącz — towar zostanie tylko zalogowany jako zwrócony",
        Usedrestock: "Używane do korekty zysku przy przyjęciu",
        Willaddedbackconfirmation: "Zostanie dodany z powrotem do magazynu po potwierdzeniu",
        Returnreason: "Powód zwrotu",
        Optional: "Opcjonalne",
        SelectReason: "Wybierz powód",
        Additionalnotes: "Dodatkowe notatki",
        Describeofcustomerexplanation: "Opisz stan zwróconego towaru, widoczne uszkodzenia, wyjaśnienie klienta...",
        Requiredmustfilledcontinue: "Wymagane pola muszą być wypełnione, aby kontynuować",
        Reviewdetailsbeforeconfirming: "Sprawdź szczegóły przed potwierdzeniem",
        Replacementproductwilldeductedinventoryconfirmation: "Produkt zastępczy zostanie odjęty z magazynu po potwierdzeniu.",
        Choosereplacementproduct: "Wybierz produkt zastępczy",
        Willdeductedfrominventoryconfirm: "Zostanie odjęty z magazynu po potwierdzeniu",
        Thesewillattachedothereturnrecord: "Te zdjęcia zostaną dołączone do rekordu zwrotu",
        Replacementitem: "Produkt zastępczy",
        Addanotherproduct: "Dodaj kolejny produkt",
        Replacementproductwillbe: "Produkt zastępczy zostanie",
        deducted: "odjęty",
        fromyourinventoryconfirmation: "z Twojego magazynu po potwierdzeniu.",
        productadjustedusingprice: "Zwrócony produkt zostanie przyjęty z powrotem, a zysk skorygowany według oryginalnej ceny sprzedaży.",
        Willloggedreturnedonlynotrestocked: "Zostanie tylko zalogowany jako zwrócony — nie zostanie przyjęty z powrotem",
        Returnonly: "Tylko zwrot",
        Imagesofreturnedproduct: "Zdjęcia zwróconego produktu",
        Returnedproductwill: "Zwrócony produkt zostanie",
        not: "nie",
        berestockedloggedreturnedonly: "przyjęty z powrotem — tylko zalogowany jako zwrócony.",
        AddImage: "Dodaj zdjęcie",
        STOCKIN: "PRZYJĘCIE",
        LOGONLY: "TYLKO LOG",
        ContinuetoReview: "Kontynuuj do przeglądu →",
        Confirmreplacement: "Potwierdź wymianę",
        Confirmreturn: "Potwierdź zwrot",
        ConfirmEdit: "Potwierdź edycję",
        Filldetailsbelowproceed: "Wypełnij dane poniżej, aby kontynuować",
        Review: "Przegląd",
        editdetails: "Edytuj dane",
        Configurereturndetails: "Skonfiguruj szczegóły zwrotu",
        Configurereplacementdetails: "Skonfiguruj szczegóły wymiany",
        SelectSource: "Wybierz źródło",
        Returning: "Zwrot",
        Replacement: "Wymiana",
        WalkCustomer: "Klient z ulicy",
        RETURNEDPRODUCT: "ZWROCONY PRODUKT",
        REPLACEMENTPRODUCT: "PRODUKT ZASTĘPCZY",
        STOCKOUT: "WYDAWANIE",
        Netinventoryimpact: "Wpływ na stan magazynowy",
        Replacementitemcost: "Koszt produktu zastępczego",
        Returneditemrestockvalue: "Wartość przyjęcia zwróconego towaru",
        PROFITINVENTORYSUMMARY: "PODSUMOWANIE ZYSKU I MAGAZYNU",
        Inventoryaction: "Akcja magazynowa",
        Valuededucted: "Wartość odjęta",
        Profitadjustment: "Korekta zysku",
        stockedout: " wydane",
        restocked: " przyjęte z powrotem",
        Noaction: "Brak akcji",
        Valuebeingreturned: "Wartość zwracana",
        Willberestocked: "Zostanie przyjęty z powrotem",
        Willbe: "Zostanie",
        logged: "zalogowany",
        ON: "WŁ.",
        OFF: "WYŁ.",
        Linked: "Powiązane",
        Pleaseselectreturnedproduct: "Proszę wybrać zwracany produkt",
        Quantityrequired: "Ilość jest wymagana",
        Buyingpricerequired: "Cena zakupu jest wymagana",
        Pleaseaddleastreplacementproduct: "Proszę dodać co najmniej jeden produkt zastępczy",
        Pleaseconfigurereturnedproductdetails: "Proszę skonfigurować szczegóły zwracanego produktu",
        Pleaseselectcustomer: "Proszę wybrać klienta",
        Returndateisrequired: "Data zwrotu jest wymagana",
        Pleasefillallrequiredfields: "Proszę wypełnić wszystkie wymagane pola",
        Wildeductedfrominventory: "Zostanie odjęty z magazynu",
        Currentprice: "Aktualna cena",
        Defectivedamaged: "Uszkodzony / wadliwy",
        Wrongitemreceived: "Otrzymano niewłaściwy produkt",
        Customerchangedmind: "Klient zmienił zdanie",
        Sizefitissue: "Problem z rozmiarem / dopasowaniem",
        Notasdescribed: "Nie zgadza się z opisem",
        Other: "Inne",
        Originalsaleprice: "Oryginalna cena sprzedaży (korekta zysku)",
        Addedbackinventory: "Dodano z powrotem do magazynu",
        Notaddedinventory: "Nie dodano do magazynu",
        replacedwith: "wymieniono na",
        deductedfrominventory: "odjęto z magazynu",
        RETURNWITHSTOCKIN: "ZWROT · Z PRZYJĘCIEM",
        RETURNNOSTOCKIN: "ZWROT · BEZ PRZYJĘCIA",
        MULTIPLEREPLACEMENTS: "WIELE WYMIAN",
        SINGLEREPLACEMENT: "POJEDYNCZA WYMIANA",
        RETURNEDSTOCKIN: "ZWROT · PRZYJĘCIE",
        REPLACEMENTSTOCKOUT: "WYMIANA · WYDAWANIE",
        Returnonlylogsthisentry: "Zwrot tylko loguje ten wpis —",
        nostockwillbeaddedorremoved: "żadne zapasy nie zostaną dodane ani usunięte",
        frominventory: "z magazynu.",
        Whentousethis: "Kiedy używać tej opcji:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Użyj Zwrotu na koniec dnia, aby zarejestrować towary wysłane na sprzedaż, które wróciły uszkodzone lub bezużyteczne — towary, które chcesz śledzić, ale nie możesz dodać z powrotem do magazynu.",
        Youcanviewallpastreturnentriesin: "Wszystkie poprzednie zwroty możesz zobaczyć w",
        ReturnHistory: "Historii zwrotów",
        underthe: "w zakładce",
        Others: "Inne",
        tab: ".",
        Negativestocktransactiondisabled: "Transakcje z ujemnym stanem magazynowym są wyłączone."
    },
    NewRLocal: {
        Originalsaleprice: "Oryginalna cena sprzedaży",
        Editinghistoryonlyinventorystaysunchanged: "Edycja historii tylko — stan magazynowy pozostaje bez zmian.",
        Changeshereupdatethisdetailsquantitiesaffected: "Zmiany tutaj aktualizują tylko szczegóły tego rekordu (powód, data, notatki). Rzeczywiste ilości magazynowe, lokalizacje bin oraz dane produktu nie są modyfikowane.",
        Needtofixinventorylevelsinstead: "Zamiast tego chcesz skorygować poziomy magazynowe?",
        AdjustStock: "Dostosuj stan magazynowy",
        Refund: "Zwrot pieniędzy",
        ImportantNote: "Ważna uwaga",
        Pleasereviewbeforecontinuing: "Proszę sprawdzić przed kontynuowaniem",
        Onceshippedreceivedanyupdatesmadeorder: "Po wysłaniu lub odebraniu zamówienia, wszelkie wprowadzone zmiany nie będą widoczne w historii transakcji.",
        Thisundone: "Ta operacja trwale usunie zamówienie. Tej akcji nie można cofnąć.",
        Inventorywilladjustedautomatically: "Stan magazynowy nie zostanie automatycznie dostosowany",
        Deletingthisreversevedshippedyouwillneed: "Usunięcie tego zamówienia nie cofa zmian w magazynie. Jeśli towary zostały już odebrane/wysłane, będziesz musiał",
        reflectthecorrectstocklevels: "aby odzwierciedlić prawidłowe stany magazynowe.",
        manuallyadjustyourinventory: "ręcznie dostosować stan magazynowy",
        Addremovestockforitemsthatwereshipped: "Dodaj lub usuń stan dla towarów, które zostały wysłane",
        Addremovestockforitemsthatwerereceived: "Dodaj lub usuń stan dla towarów, które zostały odebrane",
        Updatecostrecordspaymentwaalreadymade: "Zaktualizuj rekordy kosztów, jeśli płatność została już dokonana",
        Reconcilerecordsandoutstandingpayments: "Uzgodnij rekordy i zaległe płatności"
    },
    ReceivablesLocal: {
        Receivables: "Należności",
        Manageandtrackcustomerduebalances: "Zarządzaj i śledź należności od klientów",
        Viewcustomerduebalancereport: "Zobacz raport należności od klientów",
        Viewsupplierduebalancereport: "Zobacz raport należności od dostawców",
        DueBalance: "Należna kwota",
        Unpaid: "Nieopłacone",
        PartiallyPaid: "Częściowo opłacone",
        Paid: "Opłacone",
        HighestBalance: "Najwyższe saldo",
        LowestBalance: "Najniższe saldo",
        Filldetailsrecordpayment: "Wypełnij dane, aby zarejestrować płatność",
        NewPaymentEntry: "Nowa wpłata",
        EditPaymentEntry: "Edytuj wpłatę",
        Nosuppliersfound: "Nie znaleziono dostawców",
        Nocustomersfound: "Nie znaleziono klientów",
        LowtoHigh: "Od najniższej do najwyższej",
        HightoLow: "Od najwyższej do najniższej",
        AttachmentUploadedSc: "Załącznik wgrany pomyślnie",
        AttachmentUploadedF: "Nie udało się wgrać załącznika",
        Pay: "Zapłać",
        NoBillsFound: "Nie znaleziono rachunków",
        Thiscustomerhasunpaidbills: "Ten klient nie ma nieopłaconych rachunków.",
        TotalDue: "Razem do zapłaty",
        BillsFound: "Znaleziono rachunki",
        DeselectAll: "Odznacz wszystkie",
        SelectAll: "Zaznacz wszystkie",
        ShowDetails: "Pokaż szczegóły"
    },
    AssetsNewLocal: {
        Assignedon: "Przypisano dnia",
        Total: "Suma",
        Assigned: "Przypisane",
        Remaining: "Pozostałe",
        Available: "Dostępne",
        NoSerialNumbers: "Brak numerów seryjnych",
        UpdateExistingAssetDetails: "Aktualizuj szczegóły istniejącego zasobu",
        RegisterNewBusinessAsset: "Zarejestruj nowy zasób firmy",
        BasicInformation: "Podstawowe informacje",
        AssetDetails: "Szczegóły zasobu",
        Quantity: "Ilość",
        SerialNumbers: "Numery seryjne",
        SerialNumberPlaceholder: "Numer seryjny",
        AddSerialNumber: "Dodaj numer seryjny",
        SerialNumbersOptional: "Numery seryjne są opcjonalne. Możesz dodać maksymalnie",
        AssetImages: "Zdjęcia zasobu",
        AdditionalNotes: "Dodatkowe uwagi",
        AdditionalNotesPlaceholder: "Wszelkie dodatkowe szczegóły lub historia konserwacji...",
        Updating: "Aktualizacja...",
        Adding: "Dodawanie...",
        ITEquipmentPlaceholder: "np. Sprzęt IT",
        LoadingMoreActivities: "Ładowanie kolejnych aktywności...",
        AssignedAssets: "Przypisane środki",
        Noassetsassignedstaffmember: "Brak środków przypisanych do tego pracownika.",
        Assignassetstaff: "Przypisz środek do pracownika",
        Returnassetfromstaff: "Zwróć ten środek od pracownika",
        AssignmentDetails: "Szczegóły przypisania",
        Serial: "Numer seryjny",
        ViewAssets: "Zobacz wszystkie środki",
        ViewByStaff: "Zobacz według pracownika",
        AssignedHistory: "Historia przypisań",
        Returned: "Zwrócono",
        Returnedon: "Zwrócono dnia",
        ReturnedBy: "Zwrócone przez",
        AssignedTo: "Przypisano do",
        NoHistoryRecords: "Brak rekordów historii",
        Selectstaffmemberviewtheirassets: "Wybierz pracownika, aby zobaczyć jego środki.",
        Deleted: "USUNIĘTE",
        searchPlaceholder: "Szukaj zasobu po nazwie lub numerze seryjnym..."
    },
    InventoryCountLocale: {
        InventoryCount: "Spis Zatowarowania",
        Viewinventorycountreport: "Zobacz raport spisu zatowarowania",
        ItemsCount: "Liczba pozycji",
        All: "Wszystkie",
        InProgress: "W trakcie",
        Submitted: "Przesłano",
        awaitingreview: "Oczekuje na przegląd",
        EditInventoryCount: "Edytuj spis zatowarowania",
        NewInventoryCount: "Nowy spis zatowarowania",
        Modifyinventorycountsheetdetails: "Modyfikuj szczegóły arkusza spisu",
        Startanewinventorycountsheet: "Rozpocznij nowy arkusz spisu",
        GeneralInformation: "Informacje ogólne",
        Title: "Tytuł",
        SaveChanges: "Zapisz zmiany",
        Selectproductsforthisinventorycountsheet: "Wybierz produkty do tego arkusza spisu",
        InventoryCountDetails: "Szczegóły spisu zatowarowania",
        Inventorycountsheetdetails: "Szczegóły arkusza spisu",
        Viewingdetailsforcountsheet: "Wyświetlanie szczegółów arkusza spisu",
        Started: "Rozpoczęto",
        TaskSheets: "Arkusze zadań",
        Allitems: "Wszystkie pozycje",
        NotStarted: "Nierozpoczęte",
        Completed: "Zakończone",
        Results: "Wyniki",
        ViewResults: "Zobacz wyniki",
        DeleteInventoryCount: "Usuń spis zatowarowania",
        Viewingtransactionandadjustments: "Przeglądanie logów transakcji i korekt stanu",
        Productsadjusted: "Skorygowane produkty",
        Assignee: "Przypisano do",
        Tasksheetdetails: "Szczegóły arkusza zadania",
        Draft: "Szkic",
        VariantQuantities: "Ilości wariantów",
        AssignedProducts: "Przypisane produkty",
        ReturnAsset: "Zwróć środek",
        EditTasksheet: "Edytuj arkusz zadania",
        NewTasksheet: "Nowy arkusz zadania",
        Updatetasksheetdetails: "Aktualizuj szczegóły arkusza zadania",
        Starttasksheetforthisinventorycount: "Rozpocznij nowy arkusz zadania dla tego spisu",
        TaskSheetInformation: "Informacje o arkuszu zadania",
        SheetTitle: "Tytuł arkusza",
        Entersheettitle: "Wpisz tytuł arkusza",
        SubmissionResult: "Wynik zgłoszenia",
        ReviewChanges: "Przejrzyj zmiany",
        Viewingsubmissionresultsforthisinventorycount: "Przeglądanie wyników zgłoszenia dla tego spisu",
        Reviewyourinventorycountbeforesubmitting: "Przejrzyj spis zatowarowania przed wysłaniem"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Nie udało się załadować liczeń",
        NoInventoryCounts: "Brak spisów zatowarowania",
        NoMatches: "Brak dopasowań",
        Therearenoinventorycountswiththestatus: "Nie ma spisów zatowarowania o statusie",
        Noinventorycountsfoundyoursearchterm: "Nie znaleziono spisów zatowarowania pasujących do wyszukiwanego terminu.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Nie zarejestrowano jeszcze żadnych spisów zatowarowania dla tej firmy."
    },
    StockinModalP: {
        StockInNow: "Przyjmij stan teraz",
        Settheopeningquantityforthisproductrightnow: "Ustaw ilość początkową dla tego produktu teraz.",
        Addinitialstock: "Dodać stan początkowy?",
        dothislater: "Zrobię to później",
        Productadded: "Produkt dodany!",
        isready: "jest gotowy.",
        SeeHowItWorks: "Zobacz Jak Działa",
        NoSalesOrdersFound: "Nie znaleziono zamówień sprzedaży",
        NoPurchaseOrdersFound: "Nie znaleziono zamówień zakupu",
        Startcreatingoutgoinginventoryrevenue: "Zacznij tworzyć zamówienia sprzedaży, aby śledzić wychodzący magazyn i przychody.",
        Trackrestockssupplierplace: "Śledź uzupełnianie zapasów i zamówienia od dostawców w jednym miejscu.",
        CreateSalesOrder: "Utwórz zamówienie sprzedaży",
        CreatePurchaseOrder: "Utwórz zamówienie zakupu",
    }
    ,
    dialy_report: "Raport Ruchu Dziennego",
    Quotation: "Oferta",
    Quote: "Oferta",
    Assignee: "Przypisano do",
    dayStart: "Początek dnia",

    ShowTotalAmount: "Kwotę Ogółem",


    tutorial: {
        watchTitle: 'Obejrzyj samouczki krok po kroku',
        watchDesc: 'Ucz się SimplyStock na naszym kanale YouTube',
        modalTitle: 'Wyprzedź klientów dzięki SimplyStock',
        modalDesc: 'Subskrybuj, aby otrzymywać nowe samouczki w momencie ich publikacji',
        feature1Title: 'Nowe omówienia funkcji',
        feature1Sub: 'Każda nowa aktualizacja wyjaśniona krótkim filmem — dzięki czemu nigdy nie przegapisz tego, co nowe',
        feature2Title: 'Szybkie filmy instruktażowe',
        feature2Sub: 'Skonfiguruj zapasy, faktury, dostęp pracowników i nie tylko w mniej niż 5 minut',
        feature3Title: 'Natychmiastowe powiadomienia',
        feature3Sub: 'Otrzymuj powiadomienia w momencie uruchomienia nowego samouczka — ucz się we własnym tempie',
        feature4Title: '100% za darmo, zawsze',
        feature4Sub: 'Wszystkie samouczki są na zawsze bezpłatne — nie trzeba się logować ani subskrybować',
        subscribeBtn: 'Subskrybuj SimplyStock',
        maybeLater: 'Może później'
    }
    ,
    dailyCashReport: {
        "title": "Dzienny Raport Gotówkowy",
        "subtitle": "Kto co zapłacił, kiedy, i ile jeszcze zalega — z podsumowania sprzedaży.",
        "totalSales": "Całkowita sprzedaż",
        "cashReceived": "Suma Otrzymana",
        "outstanding": "Zaległości",
        "collectionRate": "Wskaźnik ściągalności",
        "grandTotalAllDates": "SUMA CAŁKOWITA (wszystkie daty)",
        "totalLabel": "Suma",
        "loading": "Ładowanie...",
        "noData": "Brak danych dla wybranego zakresu dat.",
        "loadingMore": "Wczytywanie więcej..."
    },
    dailyCashReportColumns: {
        "date": "Data",
        "customer": "Klient",
        "productsSold": "Sprzedane produkty",
        "products": "Produkty",
        "salesAmount": "Kwota sprzedaży",
        "sales": "Sprzedaż",
        "received": "Suma Otrzymana",
        "receivedShort": "Otrzymano",
        "debited": "Obciążono księgę",
        "due": "Należność",
        "paymentModes": "Forma płatności",
        "mode": "Tryb"
    }
}

export default pl
